import React, { Component } from "react";
import "../Drag_Drop/AdminDragDrop.css";
import {
  Button,
  Offcanvas,
  Form,
  Row,
  Col,
  Dropdown,
  Tab,
  Tabs,
  Modal,
  Table,
} from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../../config.json";
import DataTable from "react-data-table-component";

export default class AdminDragDrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      pipelines_Id: sessionStorage.getItem("pipelines_Id"),
      pipelineName: sessionStorage.getItem("pipelineName"),
      userName: sessionStorage.getItem("userName"),
      employeeowner: sessionStorage.getItem("employeeowner"),
      data: [],
      columns: [],
      draggedItem: null,
      draggedItemType: null,
      sourceColumnId: null,
      newTaskInputs: {},
      show: false,
      show1: false,
      showOne: false,
      showOffcanvasView: false,
      showOffcanvasEdit: false,
      showtwoOffcanvas: false,
      showModal: false,
      showtestcaseModal: false,
      selectedTask: null,
      filteredtescasesData: null,
      activeTabKey: "Details",
      newTask: {
        stagename: "",
        stageOrder: "",
        ittaskstable_Id: "",
        projectid: "",
        projectName: "",
        userStory: "",
        taskName: "",
        colorCode: "",
        taskDescription: "",
        assignedTo: "",
        estimatedTaskTime: "",
        estimatedHours: "",
        estimatedMinutes: "",
        actualTaskTime: "",
        taskStartTime: "",
        taskEndTime: "",
        taskReviewStartTime: "",
        taskReviewEndTime: "",
        dependencyTaskID: "",
        hours: "00",
        minutes: "00",
        deploymentRequestId: "",
        taskType: "",
        taskStatus: "",
        remarks: "",
        completedOn: "",
        requestedBy: "",
        requestType: "",
        clientRequestType: "",
        requestName: "",
        requestDate: "",
        environmentType: "",
        moduleName: "",
        releaseVersion: "",
        deploymentType: "",
        totalCount: "",
        entriesCompleted: "",
        pendingCount: "",
        dependencyTaskName: "",
        deploymentStartTime: "",
        deploymentEndTime: "",
        rollbackRequired: "",
        rollbackRemarks: "",
      },
      employees: [],
      leadstages: [],
      ittaskstable: [],
      itprojectstable: [],
      userstoriestable: [],
      filteredUserStories: [],
      filteredDependencyTasks: [],
      selectedProjectid: [],
      selectedUserStory: "",
      selectedProjectName: "",
      filteredData: null,
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      isEditingView: false,
      isEditingtestcases: false,
      bulkAction: "",
      assignToUsers: [],
      setStage: [],
      selectedTasks: [],
      activeTab: "Request1",
      taskmovementhistorytable_Id: "",
      taskID: "",
      movedFromStage: "",
      movedToStage: "",
      movedBy: "",
      movedAt: "",
      timeInStage: "",
      taskmovement: [],
      tasknotes_Id: "",
      taskid: "",
      taskNotes: "",
      tasknotes: [],
      testcases: [],
      selectedMonthLabel: "Filter by Month",
      selectedMonth: null,
      selectedYear: null,
      showStage99: false,
      ittaskstestcases_Id: "",
      ittasks_Id: "",
      testcase_title: "",
      testcase_description: "",
      testcasetypemaster: [],
      testcase_type: "Functional",
      testcaseprioritymaster: [],
      priority: "Medium",
      expected_result: "",
      test_steps: "",
      assigned_to: "",
      testcasestatusmaster: [],
      status: "",
      execution_notes: "",
      failurereason: "",
      executed_by: "",
      executed_on: "",
      estimated_hours: "",
      actual_hours: "",
      environmentmaster: [],
      taskTestCasesCount: {},
      environment: "Development",
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.tasknotes_Id,
          sortable: true,
          cell: (row) => <span>{row.tasknotes_Id}</span>,
        },
        {
          name: "Task Id",
          selector: (row, i) => row.taskid,
          sortable: true,
          cell: (row) => <span>{row.taskid}</span>,
        },
        {
          name: "Notes",
          selector: (row, i) => row.taskNotes,
          sortable: true,
          cell: (row) => <span>{row.taskNotes}</span>,
        },
        {
          name: "Created By",
          selector: (row, i) => row.createdBy,
          sortable: true,
          cell: (row) => <span>{row.createdBy}</span>,
        },
        {
          name: "Created On",
          selector: (row, i) => row.createdOn,
          sortable: true,
          cell: (row) => <span>{row.createdOn}</span>,
        },
      ],
      selectedTestcaseIds: [],
      selectedTestcase: null,
      expandedRows: {},
      taskId: "",
      dbScript: "",
      files: "",
      yes_no: [],
      codeGitStatus: "",
      location: "",
      deploymentstatus: [],
      yes_no: [],
    };
  }
  toggleExpandRow = (rowId, field) => {
    const key = `${rowId}-${field}`;
    this.setState((prevState) => ({
      expandedRows: {
        ...prevState.expandedRows,
        [key]: !prevState.expandedRows[key],
      },
    }));
  };

  IttaskstestcaseseditHandler = (row) => {
    this.setState({
      // isEditing: true,
      showModal: true,
      ittaskstestcases_Id: row.ittaskstestcases_Id,
      ittasks_Id: row.ittasks_Id,
      testcase_title: row.testcase_title,
      testcase_description: row.testcase_description,
      testcase_type: row.testcase_type,
      priority: row.priority,
      expected_result: row.expected_result,
      test_steps: row.test_steps,
      assigned_to: row.assigned_to,
      status: row.status,
      execution_notes: row.execution_notes,
      failurereason: row.failurereason,
      executed_by: row.executed_by,
      executed_on: row.executed_on,
      estimated_hours: row.estimated_hours,
      actual_hours: row.actual_hours,
      environment: row.environment,
      deploymentRequestId: row.deploymentRequestId,
      taskType: row.taskType,
      taskStatus: row.taskStatus,
      remarks: row.remarks,
      completedOn: row.completedOn,
      requestedBy: row.requestedBy,
      requestType: row.requestType,
      clientRequestType: row.clientRequestType,
      requestName: row.requestName,
      requestDate: row.requestDate,
      environmentType: row.environmentType,
      moduleName: row.moduleName,
      releaseVersion: row.releaseVersion,
      deploymentType: row.deploymentType,
      totalCount: row.totalCount,
      entriesCompleted: row.entriesCompleted,
      pendingCount: row.pendingCount,
      dependencyTaskName: row.dependencyTaskName,
      deploymentStartTime: row.deploymentStartTime,
      deploymentEndTime: row.deploymentEndTime,
      rollbackRequired: row.rollbackRequired,
      rollbackRemarks: row.rollbackRemarks,
    });
  };
  handlersCheckboxChange = (id) => {
    const { selectedTestcaseIds } = this.state;
    const updatedList = selectedTestcaseIds.includes(id)
      ? selectedTestcaseIds.filter((item) => item !== id) // remove if exists
      : [...selectedTestcaseIds, id]; // add if not

    this.setState({ selectedTestcaseIds: updatedList });
  };
  handleTimeChange = (e) => {
    const { name, value } = e.target;
    const paddedValue = value.padStart(2, "0");

    this.setState(
      {
        [name]: paddedValue,
      },
      () => {
        let { hours, minutes } = this.state;

        // Set default values
        hours = hours ? hours : "00";
        minutes = minutes ? minutes : "00";

        const timeValue = `${hours}:${minutes}`;
        this.setState({ estimatedTaskTime: timeValue });
      },
    );
  };
  handleActualTimeChange = (e) => {
    const { name, value } = e.target;
    const paddedValue = value.padStart(2, "0");

    this.setState(
      {
        [name]: paddedValue,
      },
      () => {
        let { actualHours, actualMinutes } = this.state;

        actualHours = actualHours ? actualHours : "00";
        actualMinutes = actualMinutes ? actualMinutes : "00";

        const timeValue = `${actualHours}:${actualMinutes}`;
        this.setState({ actualTaskTime: timeValue });
      },
    );
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };
  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };
  handleStageCheckboxChange = (e, column) => {
    const { selectedTasks } = this.state;
    const taskIds = column.tasks.map((task) => task.ittaskstable_Id);

    if (e.target.checked) {
      const updatedSelection = [
        ...selectedTasks,
        ...taskIds.filter((id) => !selectedTasks.includes(id)),
      ];
      this.setState({ selectedTasks: updatedSelection });
    } else {
      const updatedSelection = selectedTasks.filter(
        (id) => !taskIds.includes(id),
      );
      this.setState({ selectedTasks: updatedSelection });
    }
  };
  handleTaskCheckboxChange = (e, taskId) => {
    const { selectedTasks } = this.state;
    if (e.target.checked) {
      this.setState({ selectedTasks: [...selectedTasks, taskId] });
    } else {
      this.setState({
        selectedTasks: selectedTasks.filter((id) => id !== taskId),
      });
    }
  };
  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.tasknotes.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };
  handleBulkActionChange = (e) => {
    this.setState({
      bulkAction: e.target.value,
      assignToUsers: [],
    });
  };
  handleStageActionChange = (e) => {
    this.setState({
      bulkAction: e.target.value,
      setStage: [],
    });
  };
  handleMultiSelectChange = (e) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      (option) => option.value,
    );
    this.setState({ assignToUsers: selectedOptions });
  };
  handlestageMultiSelectChange = (e) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      (option) => option.value,
    );
    this.setState({ setStage: selectedOptions });
  };
  //stage submit event
  handleSetstageSubmit = () => {
    const { selectedTasks, setStage } = this.state;
    if (setStage.length === 0) {
      this.showToast("Please select a stage", "error");
      return;
    }
    if (selectedTasks.length === 0) {
      this.showToast("Please select at least one task", "error");
      return;
    }
    const selectedStageId = setStage[0];
    this.showToast("Updating tasks...", "info");
    let successCount = 0;
    const updatePromises = selectedTasks.map((taskId) => {
      const formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("ittaskstable_Id", taskId);
      formData.append("stagename", selectedStageId);
      return fetch(configData.api_url + "C_Ittaskstable/update", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            successCount++;
            return { success: true, taskId };
          } else {
            return { success: false, taskId, message: data.message };
          }
        });
    });
    Promise.all(updatePromises).then((results) => {
      if (successCount === selectedTasks.length) {
        this.showToast(`Successfully updated ${successCount} tasks`, "success");
      } else {
        this.showToast(
          `Updated ${successCount} out of ${selectedTasks.length} tasks`,
          "warning",
        );
      }
      this.IttaskstablefetchHandler();
      this.setState({ selectedTasks: [], setStage: [], bulkAction: "" });
    });
  };

  // assign submit event
  handleAssignSubmit = () => {
    const { selectedTasks, assignToUsers } = this.state;

    if (assignToUsers.length === 0) {
      this.showToast("Please select a user to assign", "error");
      return;
    }

    if (selectedTasks.length === 0) {
      this.showToast("Please select at least one task", "error");
      return;
    }

    const selectedUserId = assignToUsers[0]; // Get the first selected user ID
    this.showToast("Updating tasks...", "info");

    let successCount = 0;
    const updatePromises = selectedTasks.map((taskId) => {
      const formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("ittaskstable_Id", taskId);
      formData.append("assignedTo", selectedUserId);

      return fetch(configData.api_url + "C_Ittaskstable/update", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            successCount++;
            return { success: true, taskId };
          } else {
            return { success: false, taskId, message: data.message };
          }
        });
    });
    Promise.all(updatePromises).then((results) => {
      if (successCount === selectedTasks.length) {
        this.showToast(
          `Successfully assigned ${successCount} tasks`,
          "success",
        );
      } else {
        this.showToast(
          `Assigned ${successCount} out of ${selectedTasks.length} tasks`,
          "warning",
        );
      }
      this.IttaskstablefetchHandler();
      this.setState({ selectedTasks: [], assignToUsers: [], bulkAction: "" });
    });
  };
  //it tasks delete
  handleITDelete = (row, index) => {
    const { selectedTasks, sId, uId } = this.state;
    if (selectedTasks.length === 0) {
      this.showToast("No tasks selected", "error");
      return;
    }
    Promise.all(
      selectedTasks.map((taskId) => {
        const formData = new FormData();
        formData.append("sId", sId);
        formData.append("uId", uId);
        formData.append("ittaskstable_Id", taskId);

        return fetch(configData.api_url + "C_Ittaskstable/delete", {
          method: "POST",
          mode: "cors",
          body: formData,
        }).then((res) => res.json());
      }),
    ).then((results) => {
      const successCount = results.filter((r) => r.status === "success").length;
      this.showToast(`${successCount} task(s) deleted successfully`, "success");
      this.setState({ selectedTasks: [] });
      this.IttaskstablefetchHandler();
    });
  };
  //task edit event
  IttaskstableviewHandler = (taskId) => {
    const task = this.state.ittaskstable.find(
      (item) => item.ittaskstable_Id === taskId,
    );

    if (!task) {
      this.showToast("Task not found in existing data", "error");
      return;
    }

    // Find all task movements with the same taskID
    const allTaskMovements = this.state.taskmovement.filter(
      (item) => item.taskID === taskId,
    );

    // Sort by movedAt descending (latest first) and get the latest one
    const latestTaskMovement =
      allTaskMovements.length > 0
        ? allTaskMovements.sort(
            (a, b) => new Date(b.movedAt) - new Date(a.movedAt),
          )[0]
        : null;

    // Base state object with task data
    const baseState = {
      isEditingView: true,
      isEditing: false,
      isEditingtestcases: false,
      show: true,
      ittaskstable_Id: task.ittaskstable_Id,
      projectid: task.projectid,
      projectName: task.projectName,
      userStory: task.userStory,
      taskName: task.taskName,
      taskDescription: task.taskDescription,
      assignedTo: task.assignedTo,
      estimatedTaskTime: task.estimatedTaskTime,
      actualTaskTime: task.actualTaskTime,
      taskStartTime: task.taskStartTime,
      taskEndTime: task.taskEndTime,
      taskReviewStartTime: task.taskReviewStartTime,
      taskReviewEndTime: task.taskReviewEndTime,
      dependencyTaskID: task.dependencyTaskID,
      stagename: task.stagename,
      colorCode: task.colorCode || "",
      deploymentRequestId: task.deploymentRequestId || "",
      taskType: task.taskType || "",
      taskStatus: task.taskStatus || "",
      remarks: task.remarks || "",
      completedOn: task.completedOn || "",
      requestedBy: task.requestedBy || "",
      requestType: task.requestType || "",
      clientRequestType: task.clientRequestType || "",
      requestName: task.requestName || "",
      requestDate: task.requestDate || "",
      environmentType: task.environmentType || "",
      moduleName: task.moduleName || "",
      releaseVersion: task.releaseVersion || "",
      deploymentType: task.deploymentType || "",
      totalCount: task.totalCount || "",
      entriesCompleted: task.entriesCompleted || "",
      pendingCount: task.pendingCount || "",
      dependencyTaskName: task.dependencyTaskName || "",
      deploymentStartTime: task.deploymentStartTime || "",
      deploymentEndTime: task.deploymentEndTime || "",
      rollbackRequired: task.rollbackRequired || "",
      rollbackRemarks: task.rollbackRemarks || "",
    };

    // Add task movement data if it exists
    if (latestTaskMovement) {
      baseState.taskmovementhistorytable_Id =
        latestTaskMovement.taskmovementhistorytable_Id;
      baseState.taskID = latestTaskMovement.taskID;
      baseState.movedFromStage = latestTaskMovement.movedFromStage;
      baseState.movedToStage = latestTaskMovement.movedToStage;
      baseState.movedBy = latestTaskMovement.movedBy;
      baseState.movedAt = latestTaskMovement.movedAt;
      baseState.timeInStage = latestTaskMovement.timeInStage;
    } else {
      // Set default values for task movement fields when no movement data exists
      baseState.taskmovementhistorytable_Id = null;
      baseState.taskID = taskId;
      baseState.movedFromStage = null;
      baseState.movedToStage = null;
      baseState.movedBy = null;
      baseState.movedAt = null;
      baseState.timeInStage = null;
    }
    this.setState(baseState);
  };
  //month filter
  filterTasksByMonth = (tasks, monthType) => {
    const now = new Date();
    let month, year;

    if (monthType === "thisMonth") {
      month = now.getMonth();
      year = now.getFullYear();
    } else if (monthType === "lastMonth") {
      if (now.getMonth() === 0) {
        month = 11;
        year = now.getFullYear() - 1;
      } else {
        month = now.getMonth() - 1;
        year = now.getFullYear();
      }
    }

    return tasks.filter((task) => {
      const createdDate = new Date(task.createdOn);
      return (
        createdDate.getMonth() === month && createdDate.getFullYear() === year
      );
    });
  };
  updateFilteredTasks = (filteredTasks) => {
    const stageCounts = {};
    filteredTasks.forEach((task) => {
      const stage = task.stagename;
      stageCounts[stage] = (stageCounts[stage] || 0) + 1;
    });

    const { columns } = this.state;
    const newColumns = columns.map((col) => ({
      ...col,
      tasks: [],
      taskCount: stageCounts[col.id] || 0,
    }));

    filteredTasks.forEach((task) => {
      const targetColIndex = newColumns.findIndex(
        (col) => col.id === task.stagename,
      );
      if (targetColIndex !== -1) {
        newColumns[targetColIndex].tasks.push(task);
      }
    });

    this.setState({
      columns: newColumns,
    });
  };
  filterByCustomMonth = (month, year) => {
    const filtered = this.state.ittaskstable.filter((task) => {
      const createdDate = new Date(task.createdOn);
      return (
        createdDate.getMonth() === month && createdDate.getFullYear() === year
      );
    });

    this.updateFilteredTasks(filtered);
  };
  IttaskstableeditHandler = (taskId, ittasks_Id) => {
    const task = this.state.ittaskstable.find(
      (item) => item.ittaskstable_Id === taskId,
    );

    const tasknotesList = this.state.tasknotes.filter(
      (item) => item.taskid === taskId,
    );
    const filteredList = this.state.testcases.filter(
      (item) => item.ittasks_Id === taskId,
    );
    const filterdeployemntstatus = this.state.deploymentstatus.filter(
      (item) => String(item.taskId) === String(taskId), // make sure type matches
    );
    if (task) {
      const tasks = filteredList.length > 0 ? filteredList[0] : {};
      this.setState({
        filteredtescasesData: filteredList,
        filteredDeploymentStatus: filterdeployemntstatus,
        isEditing: true,
        isEditingView: false,
        isEditingtestcases: false,
        show: true,
        ittaskstable_Id: task.ittaskstable_Id,
        projectid: task.projectid,
        projectName: task.projectName,
        userStory: task.userStory,
        taskName: task.taskName,
        taskDescription: task.taskDescription,
        assignedTo: task.assignedTo,
        estimatedTaskTime: task.estimatedTaskTime,
        actualTaskTime: task.actualTaskTime,
        taskStartTime: task.taskStartTime,
        taskEndTime: task.taskEndTime,
        taskReviewStartTime: task.taskReviewStartTime,
        taskReviewEndTime: task.taskReviewEndTime,
        dependencyTaskID: task.dependencyTaskID,
        stagename: task.stagename,
        colorCode: task.colorCode || "",
        filteredData: tasknotesList,
        taskid: task.ittaskstable_Id,
        currentPage: 1,
        //task test cases
        ittaskstestcases_Id: tasks.ittaskstestcases_Id,
        ittasks_Id: tasks.ittasks_Id,
        testcase_title: "",
        testcase_description: "",
        testcase_type: tasks.testcase_type,
        priority: tasks.priority,
        expected_result: tasks.expected_result,
        test_steps: tasks.test_steps,
        assigned_to: task.assigned_to,
        status: "",
        execution_notes: tasks.execution_notes,
        failurereason: "",
        executed_by: tasks.executed_by,
        executed_on: tasks.executed_on,
        estimated_hours: tasks.estimated_hours,
        actual_hours: tasks.actual_hours,
        environment: tasks.environment,
      });
    } else {
      this.showToast("Task not found in existing data", "error");
    }
  };

  IttaskstablViewHandler = (taskId) => {
    const task = this.state.ittaskstable.find(
      (item) => item.ittaskstable_Id === taskId,
    );

    if (task) {
      this.setState({
        isEditingView: true,
        isEditing: false,
        show: true, // important to open offcanvas
        ittaskstable_Id: task.ittaskstable_Id,
        projectid: task.projectid,
        projectName: task.projectName,
        userStory: task.userStory,
        taskName: task.taskName,
        taskDescription: task.taskDescription,
        assignedTo: task.assignedTo,
        estimatedTaskTime: task.estimatedTaskTime,
        actualTaskTime: task.actualTaskTime,
        taskStartTime: task.taskStartTime,
        taskEndTime: task.taskEndTime,
        taskReviewStartTime: task.taskReviewStartTime,
        taskReviewEndTime: task.taskReviewEndTime,
        dependencyTaskID: task.dependencyTaskID,
        stagename: task.stagename,
        colorCode: task.colorCode || "",
      });
    } else {
      this.showToast("Task not found in existing data", "error");
    }
  };
  ItprojectstableupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("itprojectstable_Id", this.state.itprojectstable_Id);
    formData.append("projectid", this.state.projectid);
    formData.append("projectName", this.state.projectName);
    formData.append("projectOwner", this.state.projectOwner);
    formData.append("projectStartDate", this.state.projectStartDate);
    formData.append("projectEndDate", this.state.projectEndDate);
    formData.append("colorCode", this.state.colorCode);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFive", this.state.dummyFive);
    fetch(configData.api_url + "C_Itprojectstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ItprojectstablefetchHandler();
          this.handleOffcanvasClose();
        }
      });
  };

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };
  // It Task  Functionaliy
  handleuserStoryChange = (e) => {
    e.preventDefault();
    const selectedStory = e.target.value;
    this.setState({
      selectedUserStory: selectedStory,
      userStory: selectedStory,
    });
  };
  handlecolorCodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ colorCode: fieldValue });
  };
  handletaskNameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskName: fieldValue });
  };
  handletaskDescriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskDescription: fieldValue });
  };
  handleassignedToChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ assignedTo: fieldValue });
  };
  handlestagenameToChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ stagename: fieldValue });
  };
  handleestimatedTaskTimeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ estimatedTaskTime: fieldValue });
  };
  handleactualTaskTimeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ actualTaskTime: fieldValue });
  };
  handletaskStartTimeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskStartTime: fieldValue });
  };
  handletaskEndTimeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskEndTime: fieldValue });
  };
  handletaskReviewStartTimeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskReviewStartTime: fieldValue });
  };
  handletaskReviewEndTimeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskReviewEndTime: fieldValue });
  };
  handledependencyTaskIDChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dependencyTaskID: fieldValue });
  };
  handleResetFilter = () => {
    this.setState(
      {
        itprojectstable_Id: null,
        employees_Id: null,
        selectedMonthLabel: "Select Month",
        selectedMonth: null,
        selectedYear: null,
      },
      () => {
        this.IttaskstablefetchHandler();
        this.updateFilteredTasks(this.state.ittaskstable);
      },
    );
  };
  IttaskstablefetchHandler = () => {
    const { sId, uId, itprojectstable_Id, employees_Id, taskTestCasesCount } =
      this.state;
    const formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);
    //formData.append("user_id", uId);
    let url = configData.api_url + "C_Ittaskstable/getUsertasks";
    if (itprojectstable_Id !== null && itprojectstable_Id !== undefined) {
      formData.append("projectId", itprojectstable_Id);
      url = configData.api_url + "C_Ittaskstable/getUsertasksByProject";
    } else if (employees_Id !== null && employees_Id !== undefined) {
      formData.append("uId", employees_Id);
      url = configData.api_url + "C_Ittaskstable/getUserTasksByUserId";
    }
    fetch(url, {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const fetchedTasks = data.tasks;
          // Step 1: calculate stage-wise counts
          const stageCounts = {};
          fetchedTasks.forEach((task) => {
            const stage = task.stagename;
            stageCounts[stage] = (stageCounts[stage] || 0) + 1;
          });
          const { columns } = this.state;
          const newColumns = columns.map((col) => ({
            ...col,
            tasks: [],
            taskCount: stageCounts[col.id] || 0,
          }));

          fetchedTasks.forEach((task) => {
            const targetColIndex = newColumns.findIndex(
              (col) => col.id === task.stagename,
            );
            if (targetColIndex !== -1) {
              // newColumns[targetColIndex].tasks.push(task);
              newColumns[targetColIndex].tasks.push({
                ...task,
                // Assign the count from our pre-calculated map, default to 0 if not found
                testcasescount: taskTestCasesCount[task.ittaskstable_Id] || 0,
              });
            }
          });

          // Step 3: Update state
          this.setState({
            ittaskstable: fetchedTasks,
            columns: newColumns,
          });
        }
      });
  };
  // IttaskstablefetchHandler = () => {
  //   const { sId, uId, itprojectstable_Id } = this.state;
  //   const formData = new FormData();
  //   formData.append("sId", sId);
  //   formData.append("uId", uId);
  //   //formData.append("assignedTo", sId);
  //   let url = configData.api_url + "C_Ittaskstable/getUsertasks";

  //   if (itprojectstable_Id !== null && itprojectstable_Id !== undefined) {
  //     formData.append("projectId", itprojectstable_Id);
  //     url = configData.api_url + "C_Ittaskstable/getUsertasksByProject";
  //   }
  //   fetch(url, {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.status === "success") {
  //         const fetchedTasks = data.tasks;

  //         const { columns } = this.state;
  //         const newColumns = columns.map((col) => ({
  //           ...col,
  //           tasks: [],
  //         }));
  //         if (Array.isArray(fetchedTasks)) {
  //           fetchedTasks.forEach((task) => {
  //             const targetColIndex = newColumns.findIndex(
  //               (col) => col.id === task.stagename
  //             );
  //             if (targetColIndex !== -1) {
  //               newColumns[targetColIndex].tasks.push(task);
  //             }
  //           });
  //         }
  //         // Step 3: Update state
  //         this.setState({
  //           ittaskstable: fetchedTasks,
  //           columns: newColumns,
  //         });
  //       }
  //     });
  // };

  IttaskstablesubmitHandler = (e) => {
    e.preventDefault();
    const {
      columns,
      stagename,
      projectName,
      userStory,
      taskName,
      sId,
      uId,
      assignedTo,
      projectid,
      colorCode,
    } = this.state;
    const isDuplicate = columns.some(
      (col) =>
        col.tasks &&
        col.tasks.some(
          (task) =>
            task.taskName === taskName &&
            String(task.assignedTo) === String(assignedTo),
        ),
    );

    if (isDuplicate) {
      this.showToast(
        "Task with same name and assignee already exists.",
        "warning",
      );
      return;
    }
    const formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);
    formData.append("stagename", stagename);
    formData.append("assignedTo", assignedTo);
    formData.append("projectid", projectid);
    formData.append("projectName", projectName);
    formData.append("userStory", userStory);
    formData.append("taskName", taskName);
    formData.append("colorCode", colorCode);
    formData.append("taskDescription", this.state.taskDescription);
    formData.append("estimatedTaskTime", this.state.estimatedTaskTime);
    formData.append("actualTaskTime", this.state.actualTaskTime);
    formData.append("taskStartTime", this.state.taskStartTime);
    formData.append("taskEndTime", this.state.taskEndTime);
    formData.append("taskReviewStartTime", this.state.taskReviewStartTime);
    formData.append("taskReviewEndTime", this.state.taskReviewEndTime);
    formData.append("dependencyTaskID", this.state.dependencyTaskID);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);
    formData.append("deploymentRequestId", this.state.deploymentRequestId);
    formData.append("taskType", this.state.taskType);
    formData.append("taskStatus", this.state.taskStatus);
    formData.append("remarks", this.state.remarks);
    formData.append("completedOn", this.state.completedOn);
    formData.append("requestedBy", this.state.requestedBy);
    formData.append("requestType", this.state.requestType);
    formData.append("clientRequestType", this.state.clientRequestType);
    formData.append("requestName", this.state.requestName);
    formData.append("requestDate", this.state.requestDate);
    formData.append("environmentType", this.state.environmentType);
    formData.append("moduleName", this.state.moduleName);
    formData.append("releaseVersion", this.state.releaseVersion);
    formData.append("deploymentType", this.state.deploymentType);
    formData.append("totalCount", this.state.totalCount);
    formData.append("entriesCompleted", this.state.entriesCompleted);
    formData.append("pendingCount", this.state.pendingCount);
    formData.append("dependencyTaskName", this.state.dependencyTaskName);
    formData.append("deploymentStartTime", this.state.deploymentStartTime);
    formData.append("deploymentEndTime", this.state.deploymentEndTime);
    formData.append("rollbackRequired", this.state.rollbackRequired);
    formData.append("rollbackRemarks", this.state.rollbackRemarks);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    fetch(configData.api_url + "C_Ittaskstable/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);

        if (data.status === "success") {
          // Create new task from state values
          const newTaskItem = {
            id: `task-${Date.now()}`,
            stagename: stagename,
            projectid: projectid,
            projectName: projectName,
            userStory: userStory,
            taskName: taskName,
            colorCode: colorCode,
            taskDescription: this.state.taskDescription,
            assignedTo: this.state.assignedTo,
            estimatedTaskTime: this.state.estimatedTaskTime,
            actualTaskTime: this.state.actualTaskTime,
            taskStartTime: this.state.taskStartTime,
            taskEndTime: this.state.taskEndTime,
            taskReviewStartTime: this.state.taskReviewStartTime,
            taskReviewEndTime: this.state.taskReviewEndTime,
            dependencyTaskID: this.state.dependencyTaskID,
          };

          // Update columns with new task
          const updatedColumns = columns.map((col) => {
            if (col.id === stagename) {
              return {
                ...col,
                tasks: col.tasks ? [...col.tasks, newTaskItem] : [newTaskItem],
              };
            }
            return col;
          });

          // Update the state
          this.setState({
            columns: updatedColumns,
            // itprojectstable: [],
            projectid: "",
            projectName: "",
            // userstoriestable: [],
            userStory: "",
            taskName: "",
            colorCode: "",
            taskDescription: "",
            assignedTo: "",
            estimatedTaskTime: "",
            hours: "00",
            minutes: "00",
            actualTaskTime: "",
            actualHours: "00",
            actualMinutes: "00",
            taskStartTime: "",
            taskEndTime: "",
            taskReviewStartTime: "",
            taskReviewEndTime: "",
            dependencyTaskID: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
            showtwoOffcanvas: false,
          });
        }
      });
  };

  itprojectstablefetchHandler = () => {
    fetch(configData.api_url + "C_Itprojectstable/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ itprojectstable: data.list });
        }
      });
  };
  userstoriestablefetchHandler = () => {
    fetch(configData.api_url + "C_Userstoriestable/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ userstoriestable: data.list });
        }
      });
  };
  employeesfetchHandler = () => {
    var formData = new FormData();
    // formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Ittaskstable/getTeamMembers", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employees: data.team_ids });
        }
      });
  };
  LeadstagesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Leadstages/list", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ leadstages: data.list });
        }
      });
  };
  IttaskstestcasesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Ittaskstestcases/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const fetchedTestCases = data.list;
          const taskTestCasesCount = {};
          fetchedTestCases.forEach((testcase) => {
            const taskId = testcase.ittasks_Id;
            taskTestCasesCount[taskId] = (taskTestCasesCount[taskId] || 0) + 1;
          });
          this.setState(
            {
              //testcases: data.list
              testcases: fetchedTestCases,
              taskTestCasesCount: taskTestCasesCount,
            },
            () => {
              this.IttaskstablefetchHandler();
            },
          );
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  testcasetypemasterfetchHandler = () => {
    fetch(configData.api_url + "C_Testcasetypemaster/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ testcasetypemaster: data.list });
        }
      });
  };
  testcaseprioritymasterfetchHandler = () => {
    fetch(configData.api_url + "C_Testcaseprioritymaster/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ testcaseprioritymaster: data.list });
        }
      });
  };
  testcasestatusmasterfetchHandler = () => {
    fetch(configData.api_url + "C_Testcasestatusmaster/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ testcasestatusmaster: data.list });
        }
      });
  };
  environmentmasterfetchHandler = () => {
    fetch(configData.api_url + "C_Environmentmaster/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ environmentmaster: data.list });
        }
      });
  };
  DeploymentstatusfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Deploymentstatus/list", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ deploymentstatus: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  };
  yes_nofetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Yes_no/list", {
      // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ yes_no: data.list });
        }
      });
  };
  componentDidMount() {
    // this.fetchPipelineDetails();
    this.fetchLeadStages();
    this.itprojectstablefetchHandler();
    this.userstoriestablefetchHandler();
    this.employeesfetchHandler();
    this.LeadstagesfetchHandler();
    this.IttaskstablefetchHandler();
    this.TaskmovementhistorytablefetchHandler();
    this.TasknotesfetchHandler();
    this.IttaskstestcasesfetchHandler();
    this.testcasetypemasterfetchHandler();
    this.testcaseprioritymasterfetchHandler();
    this.testcasestatusmasterfetchHandler();
    this.environmentmasterfetchHandler();
    this.DeploymentstatusfetchHandler();
    this.yes_nofetchHandler();
  }
  //deployment onchange event
  handlelocationChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ location: fieldValue });
  };
  handletaskIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskId: fieldValue });
  };
  handledbScriptChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dbScript: fieldValue });
  };
  handlefilesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ files: fieldValue });
  };
  handlecodeGitStatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ codeGitStatus: fieldValue });
  };
  handletaskidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskid: fieldValue });
  };
  handletaskNotesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskNotes: fieldValue });
  };
  TasknotesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Tasknotes/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ tasknotes: data.list });
        }
      });
  };
  TaskmovementhistorytablefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Taskmovementhistorytable/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ taskmovement: data.list });
        }
      });
  };
  fetchLeadStages = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("pipelineId", 1);
    fetch(configData.api_url + "C_Leadstages/ListleadStagesBypipelineId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const sorted = data.list
            .filter((item) => item.pipelineId === this.state.pipelines_Id)
            .sort((a, b) => parseInt(a.stageOrder) - parseInt(b.stageOrder));
          const columns = sorted.map((stage) => ({
            id: stage.leadstages_Id,
            title: stage.stageName,
            tasks: [],
            stageOrder: parseInt(stage.stageOrder),
          }));

          this.setState({ columns });
        }
      });
  };

  // Offcanvas methods for viewing and adding tasks
  handleShowOffcanvasEdit = (task) => {
    this.setState({
      showOffcanvasEdit: true,
      selectedTaskEdit: task,
    });
  };

  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      isEditingView: false,
      projectid: "",
      projectName: "",
      userStory: "",
      taskName: "",
      taskDescription: "",
      assignedTo: "",
      estimatedTaskTime: "",
      hours: "00",
      minutes: "00",
      actualTaskTime: "",
      actualHours: "00",
      actualMinutes: "00",
      taskStartTime: "",
      taskEndTime: "",
      taskReviewStartTime: "",
      taskReviewEndTime: "",
      dependencyTaskID: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      tasknotes_Id: "",
      taskid: "",
      taskNotes: "",
    });
  };
  handleOffcanvasviewClose = () => {
    this.setState({
      show: false,
      isEditingView: false,
      isEditing: false,
      projectid: "",
      projectName: "",
      userStory: "",
      taskName: "",
      taskDescription: "",
      assignedTo: "",
      estimatedTaskTime: "",
      hours: "00",
      minutes: "00",
      actualTaskTime: "",
      actualHours: "00",
      actualMinutes: "00",
      taskStartTime: "",
      taskEndTime: "",
      taskReviewStartTime: "",
      taskReviewEndTime: "",
      dependencyTaskID: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      taskmovementhistorytable_Id: "",
      taskID: "",
      movedFromStage: "",
      movedToStage: "",
      movedBy: "",
      movedAt: "",
      timeInStage: "",
    });
  };
  handleOffcanvastestcasesClose = () => {
    this.setState({
      show: false,
      isEditingView: false,
      isEditing: false,
      isEditingtestcases: false,
      ittaskstestcases_Id: "",
      ittasks_Id: "",
      testcase_title: "",
      testcase_description: "",
      testcasetypemaster: [],
      testcase_type: "",
      testcaseprioritymaster: [],
      priority: "",
      expected_result: "",
      test_steps: "",
      assigned_to: "",
      testcasestatusmaster: [],
      status: "",
      execution_notes: "",
      failurereason: "",
      executed_by: "",
      executed_on: "",
      estimated_hours: "",
      actual_hours: "",
      environmentmaster: [],
      environment: "",
    });
  };
  handleShowOffcanvasView = (task) => {
    this.setState({
      showOffcanvasView: true,
      selectedTaskView: task,
    });
  };

  handleCloseOffcanvasView = () => {
    this.setState({ showOffcanvasView: false, selectedTaskView: null });
  };

  handletwoShowOffcanvas = (task) => {
    this.setState({
      showtwoOffcanvas: true,
      newTask: {
        stagename: "",
        ittaskstable_Id: "",
        projectid: "",
        projectName: "",
        userStory: "",
        taskName: "",
        taskDescription: "",
        assignedTo: "",
        estimatedTaskTime: "",
        actualTaskTime: "",
        taskStartTime: "",
        taskEndTime: "",
        taskReviewStartTime: "",
        taskReviewEndTime: "",
        dependencyTaskID: "",
      },
      selectedTask: task,
      // Reset top-level form fields so the form opens fresh
      projectid: "",
      projectName: "",
      userStory: "",
      taskName: "",
      taskDescription: "",
      assignedTo: "",
      estimatedTaskTime: "",
      hours: "00",
      minutes: "00",
      actualTaskTime: "",
      actualHours: "00",
      actualMinutes: "00",
      taskStartTime: "",
      taskEndTime: "",
      taskReviewStartTime: "",
      taskReviewEndTime: "",
      dependencyTaskID: "",
    });
  };

  handletwoCloseOffcanvas = () => {
    this.setState({ showtwoOffcanvas: false, selectedTask: null });
  };

  // New task form input change
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      newTask: { ...prevState.newTask, [name]: value },
    }));
  };

  handleDragStart = (e, item, type, stagename) => {
    this.setState({
      draggedItem: item,
      draggedItemType: type,
      sourceColumnId: stagename,
      showStage99: type === "card", // Show Archive Stage only when dragging cards
    });
    e.dataTransfer.setData(
      "text/plain",
      JSON.stringify({ item, type, sourceColumnId: stagename }),
    );
    e.target.style.opacity = "0.5";
  };

  handleDragEnd = (e) => {
    e.target.style.opacity = "1";
    this.setState({
      draggedItem: null,
      draggedItemType: null,
      sourceColumnId: null,
      showStage99: false, // Hide Archive Stage when drag ends
    });
  };

  handleDragOver = (e) => {
    e.preventDefault();
  };

  handleDrop = (e, targetColumnId) => {
    e.preventDefault();
    const { draggedItem, draggedItemType, columns } = this.state;
    if (!draggedItem) return;
    let updatedColumns = [...columns];
    if (draggedItemType === "column") {
      const draggedIndex = updatedColumns.findIndex(
        (col) => col.id === draggedItem.id,
      );
      const targetIndex = updatedColumns.findIndex(
        (col) => col.id === targetColumnId,
      );

      if (draggedIndex !== -1 && targetIndex !== -1) {
        const [moved] = updatedColumns.splice(draggedIndex, 1);
        updatedColumns.splice(targetIndex, 0, moved);

        // Reassign stageOrder based on new order, but preserve Archive Stage (stageOrder 99)
        updatedColumns = updatedColumns.map((col, index) => ({
          ...col,
          stageOrder: col.stageOrder === 99 ? 99 : index + 1, // Archive Stage keeps stageOrder 99
        }));

        this.setState({ columns: updatedColumns }, () => {
          this.updateStageOrderOnServer(updatedColumns); // Call API to update order
        });
      }
    }

    this.setState({ draggedItem: null, draggedItemType: null });
  };

  deleteTask = (stagename, taskId) => {
    this.setState((prevState) => {
      const updatedColumns = prevState.columns.map((col) => {
        if (col.id === stagename && col.tasks) {
          return {
            ...col,
            tasks: col.tasks.filter((task) => task.id !== taskId),
          };
        }
        return col;
      });
      return { columns: updatedColumns };
    });
  };
  updateStageOrderOnServer = (columns) => {
    const { sId, uId } = this.state;

    // Filter out Archive Stage (stageOrder 99) from server updates
    columns
      .filter((col) => col.stageOrder !== 99)
      .forEach((col) => {
        const formData = new FormData();
        formData.append("sId", sId);
        formData.append("uId", uId);
        formData.append("leadstages_Id", col.id);
        formData.append("stageOrder", col.stageOrder); // new order

        fetch(configData.api_url + "C_Leadstages/update", {
          method: "POST",
          mode: "cors",
          body: formData,
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === "success") {
              this.showToast(data.message, data.status);
            }
          });
      });
  };
  handleCardDragStart = (task, sourceColumnId) => {
    this.setState({
      draggedItem: task,
      draggedItemType: "card",
      sourceColumnId,
      showStage99: true,
    });
  };
  handleCardDragOver = (e) => {
    e.preventDefault(); // Allow drop
  };
  // Modify handleCardDrop to refresh tasks after the update
  handleCardDrop = (targetColumnId) => {
    const { draggedItem, sourceColumnId, columns, draggedItemType } =
      this.state;
    if (draggedItem && draggedItemType === "card") {
      // Check if target is Archive Stage (stageOrder 99)
      const targetColumn = columns.find((col) => col.id === targetColumnId);
      const isArchiveStage = targetColumn && targetColumn.stageOrder === 99;

      let updatedColumns;

      if (isArchiveStage) {
        // For Archive Stage: only remove from source, don't add to target (tasks won't be visible)
        updatedColumns = columns.map((col) => {
          if (col.id === sourceColumnId) {
            return {
              ...col,
              tasks: col.tasks.filter((task) => task.id !== draggedItem.id),
            };
          }
          return col;
        });
      } else {
        // For regular stages: normal behavior (move from source to target)
        updatedColumns = columns.map((col) => {
          if (col.id === sourceColumnId) {
            return {
              ...col,
              tasks: col.tasks.filter((task) => task.id !== draggedItem.id),
            };
          } else if (col.id === targetColumnId) {
            return {
              ...col,
              tasks: [
                ...col.tasks,
                { ...draggedItem, stagename: targetColumnId },
              ],
            };
          }
          return col;
        });
      }

      // Call the API to update the task's stage on the server
      const taskId = draggedItem.ittaskstable_Id || draggedItem.id;
      const movedFromStage = sourceColumnId;
      const movedToStage = targetColumnId;
      const movedBy = this.state.uId || "system";
      const movedAt = new Date().toISOString();

      this.setState(
        {
          columns: updatedColumns,
          draggedItem: null,
          draggedItemType: null,
          sourceColumnId: null,
          taskID: taskId,
          movedFromStage,
          movedToStage,
          movedBy,
          movedAt,
          timeInStage: "",
          showStage99: false, // Always hide Archive Stage after drop
        },
        () => {
          // Update the task on the server
          this.updateTaskStage(taskId, targetColumnId, () => {
            // After the API call completes, refresh all tasks to ensure sync with server
            this.IttaskstablefetchHandler();
            this.TaskmovementhistorytablesubmitHandler();

            // Show success message for archiving
            if (isArchiveStage) {
              this.showToast("Task archived successfully", "success");
            }
          });
        },
      );
    }
  };

  // Update the updateTaskStage method to accept a callback
  updateTaskStage = (taskId, newStageId, callback) => {
    const { sId, uId } = this.state;
    const formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);
    formData.append("ittaskstable_Id", taskId);
    formData.append("stagename", newStageId);
    // Include any other required fields for your API

    fetch(configData.api_url + "C_Ittaskstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, data.status);
        } else {
          this.showToast(
            data.message || "Failed to update task stage",
            "error",
          );
        }

        // Call the callback function if provided
        if (typeof callback === "function") {
          callback();
        }
      })
      .catch((error) => {
        this.showToast("Failed to update task stage", "error");
        // Call the callback function even on error
        if (typeof callback === "function") {
          callback();
        }
      });
  };
  handleprojectidChange = (e) => {
    const selectedProjectId = e.target.value;

    const selectedProject = this.state.itprojectstable.find(
      (project) => project.itprojectstable_Id === selectedProjectId,
    );

    const selectedProjectName = selectedProject?.projectName || "";

    const filteredUserStories = this.state.userstoriestable.filter(
      (story) => story.projectName === selectedProjectName,
    );

    const filteredDependencyTasks = this.state.ittaskstable.filter(
      (task) => task.projectName === selectedProjectName,
    );

    const filteredStages = this.state.leadstages.filter(
      (stage) => stage.projectName === selectedProjectName,
    );

    this.setState({
      projectid: selectedProjectId,
      projectName: selectedProjectName,
      colorCode: selectedProject?.colorCode || "",
      filteredUserStories,
      filteredDependencyTasks,
      filteredStages,
    });
  };
  handleprojectNameChange = (e) => {
    e.preventDefault();
    const selectedProjectName = e.target.value;
    //const fieldValue = e.target.value;
    const selectedProject = this.state.itprojectstable.find(
      (project) => project.projectName === selectedProjectName,
    );
    const selectedProjectId = selectedProject?.itprojectstable_Id || "";
    const filteredUserStories = this.state.userstoriestable.filter(
      (story) => story.projectName === selectedProjectName,
    );

    const filteredDependencyTasks = this.state.ittaskstable.filter(
      (task) => task.projectName === selectedProjectName,
    );
    this.setState({
      projectid: selectedProjectId,
      projectName: selectedProjectName,
      selectedProjectName, // 👈 IMPORTANT
      selectedUserStory: "", // reset story selection
      colorCode: selectedProject?.colorCode,
      filteredUserStories,
      filteredDependencyTasks,
    });
  };
  IttaskstableupdateHandler = (e) => {
    const {
      sId,
      uId,
      stagename,
      assignedTo,
      projectName,
      userStory,
      taskName,
      taskDescription,
      dependencyTaskID,
      ittaskstable_Id,
      estimatedTaskTime,
      actualTaskTime,
      colorCode,
    } = this.state;
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", sId);
    formData.append("uId", uId);
    formData.append("ittaskstable_Id", ittaskstable_Id);
    formData.append("stagename", stagename);
    formData.append("colorCode", colorCode);
    formData.append("assignedTo", assignedTo);
    formData.append("projectName", projectName);
    formData.append("userStory", userStory);
    formData.append("taskName", taskName);
    formData.append("taskDescription", taskDescription);
    formData.append("dependencyTaskID", dependencyTaskID);
    formData.append("estimatedTaskTime", estimatedTaskTime);
    formData.append("actualTaskTime", actualTaskTime);
    formData.append("taskStartTime", this.state.taskStartTime);
    formData.append("taskEndTime", this.state.taskEndTime);
    formData.append("taskReviewStartTime", this.state.taskReviewStartTime);
    formData.append("taskReviewEndTime", this.state.taskReviewEndTime);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);
    formData.append("deploymentRequestId", this.state.deploymentRequestId);
    formData.append("taskType", this.state.taskType);
    formData.append("taskStatus", this.state.taskStatus);
    formData.append("remarks", this.state.remarks);
    formData.append("completedOn", this.state.completedOn);
    formData.append("requestedBy", this.state.requestedBy);
    formData.append("requestType", this.state.requestType);
    formData.append("clientRequestType", this.state.clientRequestType);
    formData.append("requestName", this.state.requestName);
    formData.append("requestDate", this.state.requestDate);
    formData.append("environmentType", this.state.environmentType);
    formData.append("moduleName", this.state.moduleName);
    formData.append("releaseVersion", this.state.releaseVersion);
    formData.append("deploymentType", this.state.deploymentType);
    formData.append("totalCount", this.state.totalCount);
    formData.append("entriesCompleted", this.state.entriesCompleted);
    formData.append("pendingCount", this.state.pendingCount);
    formData.append("dependencyTaskName", this.state.dependencyTaskName);
    formData.append("deploymentStartTime", this.state.deploymentStartTime);
    formData.append("deploymentEndTime", this.state.deploymentEndTime);
    formData.append("rollbackRequired", this.state.rollbackRequired);
    formData.append("rollbackRemarks", this.state.rollbackRemarks);
    formData.append("deploymentRequest_Id", this.state.deploymentRequest_Id);
    //***tableData1
    fetch(configData.api_url + "C_Ittaskstable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstablefetchHandler();
          this.handleOffcanvasClose();
        }
      });
  };
  TaskmovementhistorytablesubmitHandler = (e) => {
    if (e) e.preventDefault(); // Allow both manual call and form submission

    const formData = new FormData();
    formData.append("sId", this.state.sId); // Adjust as needed
    formData.append("uId", this.state.uId);
    formData.append("taskID", this.state.taskID);
    formData.append("movedFromStage", this.state.movedFromStage);
    formData.append("movedToStage", this.state.movedToStage);
    formData.append("movedBy", this.state.movedBy);
    formData.append("movedAt", this.state.movedAt);
    formData.append("timeInStage", this.state.timeInStage || "");
    formData.append("dummyOne", "");
    formData.append("dummyTwo", "");
    formData.append("dummyThree", "");
    formData.append("dummyFour", "");
    formData.append("dummyFive", "");

    fetch(configData.api_url + "C_Taskmovementhistorytable/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TaskmovementhistorytablefetchHandler();
          this.setState({
            taskID: "",
            movedFromStage: "",
            movedToStage: "",
            movedBy: "",
            movedAt: "",
            timeInStage: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      });
  };
  TasknotessubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("taskid", this.state.taskid);
    formData.append("taskNotes", this.state.taskNotes);
    //***tableData*
    fetch(configData.api_url + "C_Tasknotes/add", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TasknotesfetchHandler();
          this.IttaskstablefetchHandler();
          this.handleOffcanvasClose();
          this.setState({ taskid: "", taskNotes: "" });
        }
      });
  };
  DeploymentstatussubmitHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("taskId", this.state.taskid);
    formData.append("dbScript", this.state.dbScript);
    formData.append("files", this.state.files);
    formData.append("codeGitStatus", this.state.codeGitStatus);
    formData.append("location", this.state.location);
    fetch(configData.api_url + "C_Deploymentstatus/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.DeploymentstatusfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            taskId: "",
            dbScript: "",
            files: "",
            codeGitStatus: "",
            location: "",
          });
        }
      })
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      });
  };
  validateForm() {
    let data = this.state;
    let errors = {};
    let formIsValid = true;
    if (!data["testcase_title"]) {
      formIsValid = false;
      toast.error("*Please Enter Test Case Title.");
    } else if (!data["testcase_description"]) {
      formIsValid = false;
      toast.error("*Please Enter Test Case Description.");
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  IttaskstestcasessubmitHandler = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      var formData = new FormData();
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("ittasks_Id", this.state.ittaskstable_Id);
      formData.append("testcase_title", this.state.testcase_title);
      formData.append("testcase_description", this.state.testcase_description);
      formData.append("testcase_type", "Functional");
      formData.append("priority", "Medium");
      formData.append("expected_result", "");
      formData.append("test_steps", "");
      formData.append("assigned_to", this.state.uId);
      formData.append("status", this.state.status);
      formData.append("execution_notes", "");
      formData.append("failurereason", this.state.failurereason);
      formData.append("executed_by", "");
      formData.append("executed_on", "");
      formData.append("estimated_hours", "");
      formData.append("actual_hours", "");
      formData.append("environment", "Development");
      fetch(configData.api_url + "C_Ittaskstestcases/add", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.status);
          if (data.status === "success") {
            this.IttaskstestcasesfetchHandler();
            this.IttaskstablefetchHandler();
            this.setState({ showtestcaseModal: false });
            // this.handleOffcanvasClose();
            this.setState({
              ittasks_Id: "",
              testcase_title: "",
              testcase_description: "",
              testcasetypemaster: [],
              testcase_type: "",
              testcaseprioritymaster: [],
              priority: "",
              expected_result: "",
              test_steps: "",
              assigned_to: "",

              status: "",
              execution_notes: "",
              failurereason: "",
              executed_by: "",
              executed_on: "",
              estimated_hours: "",
              actual_hours: "",
              environmentmaster: [],
              environment: "",
            });
          }
        })
        .catch((error) => {
          console.error("Submit error:", error);
          this.showToast("Failed to save data", "error");
        });
    }
  };
  validateupdateForm() {
    let data = this.state;
    let errors = {};
    let formIsValid = true;
    if (!data["status"]) {
      formIsValid = false;
      toast.error("*Please Select Status.");
    } else if (!data["failurereason"]) {
      formIsValid = false;
      toast.error("*Please Enter Remarks.");
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }
  IttaskstestcasesupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    if (this.validateupdateForm()) {
      formData.append("sId", this.state.sId);
      formData.append("uId", this.state.uId);
      formData.append("ittaskstestcases_Id", this.state.ittaskstestcases_Id);
      formData.append("ittasks_Id", this.state.ittaskstable_Id);
      formData.append("testcase_title", this.state.testcase_title);
      formData.append("testcase_description", this.state.testcase_description);
      formData.append("testcase_type", "Functional");
      formData.append("priority", "Medium");
      formData.append("expected_result", "");
      formData.append("test_steps", "");
      formData.append("assigned_to", this.state.uId);
      formData.append("status", this.state.status);
      formData.append("execution_notes", "");
      formData.append("failurereason", this.state.failurereason);
      formData.append("executed_by", "");
      formData.append("executed_on", "");
      formData.append("estimated_hours", "");
      formData.append("actual_hours", "");
      formData.append("environment", "Developmemnt");
      fetch(configData.api_url + "C_Ittaskstestcases/update", {
        method: "POST",
        mode: "cors",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          this.showToast(data.message, data.status);
          if (data.status === "success") {
            this.IttaskstestcasesfetchHandler();
            this.IttaskstablefetchHandler();
            // this.handleOffcanvasClose();
            this.setState({ showModal: false });
          }
        })
        .catch((error) => {
          console.error("Update error:", error);
          this.showToast("Failed to update data", "error");
        });
    }
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("ittaskstestcases_Id", row.ittaskstestcases_Id);

    fetch(configData.api_url + "C_Ittaskstestcases/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.IttaskstestcasesfetchHandler();
          this.IttaskstablefetchHandler();
        }
      })
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      });
  };
  //test cases events
  handleittasks_IdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ittasks_Id: fieldValue });
  };
  handletestcase_titleChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ testcase_title: fieldValue });
  };
  handletestcase_descriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ testcase_description: fieldValue });
  };
  handletestcase_typeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ testcase_type: fieldValue });
  };
  handlepriorityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ priority: fieldValue });
  };
  handleexpected_resultChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ expected_result: fieldValue });
  };
  handletest_stepsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ test_steps: fieldValue });
  };
  handleassigned_toChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ assigned_to: fieldValue });
  };
  handlestatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ status: fieldValue });
  };
  handleexecution_notesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ execution_notes: fieldValue });
  };
  handlefailurereasonChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ failurereason: fieldValue });
  };
  handleexecuted_byChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ executed_by: fieldValue });
  };
  handleexecuted_onChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ executed_on: fieldValue });
  };
  handleestimated_hoursChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ estimated_hours: fieldValue });
  };
  handleactual_hoursChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ actual_hours: fieldValue });
  };
  handleenvironmentChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ environment: fieldValue });
  };
  // Add this method to your component
  isCurrentUserReportingManager = () => {
    if (!this.state.employees || !this.state.uId) {
      return false;
    }

    // Convert both to string for comparison to avoid type mismatch
    return this.state.employees.some(
      (employee) => employee.rmId.toString() === this.state.uId.toString(),
    );
  };
  render() {
    const {
      columns,

      showtwoOffcanvas,
    } = this.state;
    const pipelineName = sessionStorage.getItem("pipelineName");
    const { bulkAction } = this.state;
    const selectedTaskId = this.state.ittaskstable_Id;
    const filteredTestCases = this.state.testcases.filter(
      (test) => test.ittasks_Id === selectedTaskId,
    );

    return (
      <div className="mx-auto p-4">
        <Row>
          <div className="col-6">
            <p className="p-1">
              <b> Name: </b>
              {pipelineName}
            </p>
          </div>
          <div className="col-6 text-end">
            <Button
              variant="success"
              className="mb-4 mt-1 rounded-0"
              onClick={() => this.handletwoShowOffcanvas()}
            >
              + Add New Task
            </Button>
          </div>
        </Row>
        {/* {this.state.userName &&
                  this.state.employeeowner &&
                  this.state.userName.includes(this.state.employeeowner) && ( */}
        {this.state.employees.length > 0 && (
          <Row className="align-items-end">
            <Col lg="1">
              <Dropdown className="d-inline-block">
                <Dropdown.Toggle id="dropdown-basic" className="mb-2 rounded-0">
                  Filter
                </Dropdown.Toggle>
                <Dropdown.Menu className="main-dropdown">
                  <div className="dropdown-submenu">
                    <Dropdown.Item className="submenu-toggle">
                      By user
                    </Dropdown.Item>
                    <ul className="dropdown-menu">
                      <li>
                        <Dropdown.Item
                          key="all"
                          onClick={() => {
                            this.setState({ employees_Id: null }, () =>
                              this.IttaskstablefetchHandler(),
                            );
                          }}
                        >
                          Users List
                        </Dropdown.Item>
                        {this.state.employees
                          .slice()
                          .sort((a, b) => {
                            const nameA = a.fName.toLowerCase();
                            const nameB = b.fName.toLowerCase();
                            if (nameA < nameB) return -1;
                            if (nameA > nameB) return 1;
                            return 0;
                          })
                          .map((api, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={() => {
                                this.setState(
                                  {
                                    employees_Id: api.employees_Id,
                                  },
                                  () => this.IttaskstablefetchHandler(),
                                );
                              }}
                            >
                              {api.fName}&nbsp;{api.lName}
                            </Dropdown.Item>
                          ))}
                        {/* {this.state.employees.map((api, index, idx) => (
                        <Dropdown.Item
                          className="submenu-toggle"
                          key={index}
                          value={api.employees_Id}
                        >
                          {api.fName}&nbsp;{api.lName}
                        </Dropdown.Item>
                      ))} */}
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown-submenu">
                    <Dropdown.Item className="submenu-toggle">
                      By Project
                    </Dropdown.Item>
                    <ul className="dropdown-menu">
                      <li>
                        <Dropdown.Item
                          key="all"
                          onClick={() => {
                            this.setState({ itprojectstable_Id: null }, () =>
                              this.IttaskstablefetchHandler(),
                            );
                          }}
                        >
                          Project List
                        </Dropdown.Item>

                        {this.state.itprojectstable
                          .slice()
                          .sort((a, b) => {
                            const nameA = a.projectName.toLowerCase();
                            const nameB = b.projectName.toLowerCase();
                            if (nameA < nameB) return -1;
                            if (nameA > nameB) return 1;
                            return 0;
                          })
                          .map((api, index) => (
                            <Dropdown.Item
                              key={index}
                              onClick={() => {
                                this.setState(
                                  {
                                    itprojectstable_Id: api.itprojectstable_Id,
                                  },
                                  () => this.IttaskstablefetchHandler(),
                                );
                              }}
                            >
                              {api.projectName}
                            </Dropdown.Item>
                          ))}
                      </li>
                    </ul>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col lg="2">
              <Form.Group className="form-group">
                <Form.Select
                  name="bulkAction"
                  value={bulkAction}
                  onChange={this.handleBulkActionChange}
                  className="form-control"
                  // style={{ height: "47px" }}
                >
                  <option value="">Bulk Actions</option>
                  <option value="Assignto">Assign To</option>
                  <option value="setstage">Set Stage</option>
                  <option value="delete">Delete</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {this.state.bulkAction === "Assignto" && (
              <Col lg="2">
                <Form.Group className="form-group">
                  <Form.Select
                    name="assignToUsers"
                    value={this.state.assignToUsers}
                    onChange={this.handleMultiSelectChange}
                  >
                    <option value="">Assign Members</option>
                    {this.state.employees
                      .slice()
                      .sort((a, b) => {
                        const nameA = a.fName.toLowerCase();
                        const nameB = b.fName.toLowerCase();
                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;
                        return 0;
                      })
                      .map((api, index, idx) => (
                        <option key={index} value={api.employees_Id}>
                          {api.fName}&nbsp;{api.lName}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
            {this.state.bulkAction === "setstage" && (
              <Col lg="2">
                <Form.Group className="form-group">
                  <Form.Select
                    name="setStage"
                    value={this.state.setStage}
                    onChange={this.handlestageMultiSelectChange}
                  >
                    <option value="">Stages</option>
                    {this.state.leadstages
                      .slice()
                      .sort((a, b) => {
                        const nameA = a.stageName.toLowerCase();
                        const nameB = b.stageName.toLowerCase();
                        if (nameA < nameB) return -1;
                        if (nameA > nameB) return 1;
                        return 0;
                      })
                      .map((api, index) => (
                        <option key={index} value={api.leadstages_Id}>
                          {api.stageName}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
            {this.state.bulkAction === "setstage" && (
              <Col lg="1">
                <Button
                  variant="primary"
                  className="mt-1 mb-2 rounded-0"
                  onClick={this.handleSetstageSubmit}
                >
                  Submit
                </Button>
              </Col>
            )}
            {this.state.bulkAction === "Assignto" && (
              <Col lg="1">
                <Button
                  variant="primary"
                  className="mt-1 mb-2 rounded-0"
                  onClick={this.handleAssignSubmit}
                >
                  Submit
                </Button>
              </Col>
            )}
            {this.state.bulkAction === "delete" && (
              <Col lg="1">
                <Button
                  variant="primary"
                  className="mt-1 mb-2 rounded-0"
                  onClick={this.handleITDelete}
                >
                  Submit
                </Button>
              </Col>
            )}
            <Col lg="1">
              <Button
                variant="secondary"
                className="mt-1 mb-2 rounded-0"
                onClick={this.handleResetFilter}
              >
                Reset
              </Button>
            </Col>
            {/* <Col lg="2" style={{ width: "120px" }}>
              <Button
                variant="secondary"
                className="mt-1 mb-2 rounded-0"
                onClick={() => {
                  const filtered = this.filterTasksByMonth(
                    this.state.ittaskstable,
                    "lastMonth"
                  );
                  this.updateFilteredTasks(filtered);
                }}
              >
                Last Month
              </Button>
            </Col>
            <Col lg="2" style={{ width: "120px" }}>
              <Button
                variant="secondary"
                className="mt-1 mb-2 rounded-0"
                onClick={() => {
                  const filtered = this.filterTasksByMonth(
                    this.state.ittaskstable,
                    "thisMonth"
                  );
                  this.updateFilteredTasks(filtered);
                }}
              >
                This Month
              </Button>
            </Col> */}
            <Col>
              <Dropdown>
                <Dropdown.Toggle id="dropdown-basic" className="mb-2 rounded-0">
                  {this.state.selectedMonthLabel}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {[
                    { month: 0, label: "January" },
                    { month: 1, label: "February" },
                    { month: 2, label: "March" },
                    { month: 3, label: "April" },
                    { month: 4, label: "May" },
                    { month: 5, label: "June" },
                    { month: 6, label: "July" },
                    { month: 7, label: "August" },
                    { month: 8, label: "September" },
                    { month: 9, label: "October" },
                    { month: 10, label: "November" },
                    { month: 11, label: "December" },
                  ].map((item) => (
                    <Dropdown.Item
                      key={item.month}
                      onClick={() => {
                        const selectedLabel = `${item.label} 2025`;
                        this.setState(
                          {
                            selectedMonthLabel: selectedLabel,
                            selectedMonth: item.month,
                            selectedYear: 2025,
                          },
                          () => {
                            this.filterByCustomMonth(item.month, 2025);
                          },
                        );
                      }}
                    >
                      {item.label} 2025
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        )}
        {/* )} */}
        <div
          className="flex space-x-4 overflow-x-auto"
          style={{ display: "flex" }}
        >
          {columns
            .filter((column) => column.stageOrder !== 99)
            .map((column) => (
              <div
                key={column.id}
                draggable
                onDragStart={(e) =>
                  this.handleDragStart(e, column, "column", column.id)
                }
                onDragEnd={this.handleDragEnd}
                className="flex-1 bg-gray-100 rounded-lg kanban-column"
                onDragOver={(e) => {
                  e.preventDefault(); // Allow dropping
                  e.stopPropagation();
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  // Check if we're dropping a card or reordering columns
                  if (this.state.draggedItemType === "card") {
                    this.handleCardDrop(column.id);
                  } else if (this.state.draggedItemType === "column") {
                    this.handleDrop(e, column.id);
                  }
                }}
                style={{
                  backgroundColor: "white",
                  width: "370px",
                  cursor: "grab",
                }}
              >
                <div className="kanbanHeader" style={{ color: "red" }}>
                  <div className="row">
                    <div
                      className="col-12"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        color: "#616161",
                      }}
                    >
                      <div>{column.title}</div>
                      <div>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          // value=""
                          // onClick={(e) => e.stopPropagation()}
                          // value={task.ittaskstable_Id}
                          // aria-hidden="true"
                          // onChange={(e) =>
                          //   this.handleTaskCheckboxChange(
                          //     e,
                          //     task.ittaskstable_Id
                          //   )
                          // }
                          // checked={this.state.selectedTasks.includes(
                          //   task.ittaskstable_Id
                          // )}
                          // onClick={(e) => e.stopPropagation()}
                          checked={
                            column.tasks?.length > 0 &&
                            column.tasks.every((task) =>
                              this.state.selectedTasks.includes(
                                task.ittaskstable_Id,
                              ),
                            )
                          }
                          onChange={(e) =>
                            this.handleStageCheckboxChange(e, column)
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row pt-1 pb-1">
                    <div
                      className="col-8"
                      style={{ fontStyle: "12px", color: "#616161" }}
                    >
                      <p
                        style={{
                          color: "#9c9c9c",
                          display: "inline",
                          paddingRight: "10px",
                        }}
                      >
                        Total Tasks
                      </p>
                    </div>
                    <div className="col-4 text-end">
                      <div
                        style={{
                          display: "inline-block",
                          // width: "35px",
                          padding: "0px 10px",
                          height: "20px",
                          lineHeight: "20px",
                          borderRadius: "10px",
                          backgroundColor: "#3ca8e8",
                          color: "#ffffff",
                          textAlign: "center",
                          fontSize: "12px",
                          // fontWeight: "bold",
                        }}
                      >
                        {column.taskCount}
                      </div>
                    </div>
                    {/* <div className="col-12" style={{fontStyle:"12px"}}>{column.stageOrder}</div> */}
                  </div>
                </div>

                {/* Task container */}
                <div
                  className="space-y-2 task-container"
                  style={{
                    minHeight: "100px",
                    padding: "8px",
                  }}
                >
                  {column.tasks &&
                    column.tasks.map((task) => (
                      <div
                        key={task.id}
                        draggable
                        onDragStart={(e) => {
                          e.stopPropagation(); // Prevent column drag events from firing
                          this.handleCardDragStart(task, column.id);
                        }}
                        onDragEnd={this.handleDragEnd}
                        className="task-card dragDrop"
                        style={{
                          maxWidth: "18rem",
                          cursor: "grab",
                          userSelect: "none",
                          marginBottom: "10px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <ul
                          className="list-group list-group-light"
                          style={{
                            borderTop: `3px solid ${
                              task.colorCode || "#3ca8e8"
                            }`,
                          }}
                        >
                          <li className="list-group-item d-flex justify-content-between align-items-center p-1">
                            {/*<p>{task.ittaskstable_Id || task.id}</p>*/}
                            <span style={{ fontSize: "12px" }}>
                              <p>Task Id : {task.ittaskstable_Id}</p>
                            </span>
                            <span className="badge-primary ">
                              {/* <i
                              className="bi bi-eye-fill"
                              aria-hidden="true"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.IttaskstableviewHandler(
                                  task.ittaskstable_Id
                                );
                                this.setState({ isEditingView: true });
                              }}
                            ></i>
                            <i
                              className="bi bi-pencil"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.IttaskstableeditHandler(
                                  task.ittaskstable_Id
                                );
                                this.setState({ isEditing: true });
                              }}
                              aria-hidden="true"
                              style={{ paddingRight: "8px" }}
                            ></i>
                            &nbsp; */}
                              <input
                                className="form-check-input"
                                type="checkbox"
                                // value=""
                                // onClick={(e) => e.stopPropagation()}
                                value={task.ittaskstable_Id}
                                aria-hidden="true"
                                onChange={(e) =>
                                  this.handleTaskCheckboxChange(
                                    e,
                                    task.ittaskstable_Id,
                                  )
                                }
                                checked={this.state.selectedTasks.includes(
                                  task.ittaskstable_Id,
                                )}
                                onClick={(e) => e.stopPropagation()}
                              />
                            </span>
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center p-1">
                            {/* <span>{task.assignedTo}</span> */}
                            <div
                              style={{
                                color: `${task.colorCode || "#3ca8e8"}`,
                              }}
                            >
                              {task.projectName}
                            </div>
                            <div
                              style={{
                                color: `${task.colorCode || "#3ca8e8"}`,
                              }}
                            >
                              Test cases : {task.testcasescount}
                            </div>
                          </li>
                          <li className="list-group-item align-items-end  p-1">
                            {task.taskName}
                          </li>
                          <li className="list-group-item d-flex justify-content-between align-items-center p-1">
                            {/* {task.stagename} */}
                            <span style={{ fontSize: "11px" }}>
                              {(() => {
                                const emp = this.state.employees.find(
                                  (e) =>
                                    String(e.employees_Id) ===
                                    String(task.assignedTo),
                                );
                                return emp ? `${emp.fName}` : "N/A";
                              })()}
                            </span>
                            <span className="badge badge-primary">
                              <i
                                className="bi bi-journal-check"
                                aria-hidden="true"
                                onClick={(e) => {
                                  this.IttaskstableeditHandler(
                                    task.ittaskstable_Id,
                                  );
                                  this.setState({
                                    isEditingtestcases: true,
                                    activeTabKey: "Cases",
                                  });
                                }}
                              ></i>
                              <i
                                className="bi bi-eye-fill"
                                aria-hidden="true"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.IttaskstableviewHandler(
                                    task.ittaskstable_Id,
                                  );
                                  this.setState({ isEditingView: true });
                                }}
                              ></i>
                              <i
                                className="bi bi-pencil"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.IttaskstableeditHandler(
                                    task.ittaskstable_Id,
                                  );
                                  this.setState({
                                    isEditing: true,
                                    activeTabKey: "Send123",
                                  });
                                }}
                                aria-hidden="true"
                                // style={{ paddingRight: "8px" }}
                              ></i>

                              {/* <i
                              className="bi bi-telephone-fill"
                              aria-hidden="true"
                            ></i>
                            <i
                              className="bi bi-envelope"
                              aria-hidden="true"
                            ></i>
                            <i
                              className="bi bi-plus-square dropdown-toggle"
                              aria-hidden="true"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            ></i>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <Link className="dropdown-item" to="/">
                                  Action
                                </Link>
                              </li>
                              <li>
                                <Link className="dropdown-item" to="#">
                                  Another action
                                </Link>
                              </li>
                              <li>
                                <Link className="dropdown-item" to="#">
                                  Something else here
                                </Link>
                              </li>
                            </ul> */}
                            </span>
                          </li>
                        </ul>
                      </div>
                    ))}
                </div>
                {this.state.isEditing && (
                  // Edit Offcanvas
                  <Offcanvas
                    show={this.state.isEditing}
                    // onHide={() => this.setState({ isEditing: false })}
                    onHide={this.handleOffcanvasClose}
                    {...this.props}
                    style={{ width: "800px" }}
                    placement="end"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>Edit IT Tasks</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Tabs
                        defaultActiveKey="Send123"
                        id="justify-tab-example"
                        justify={true.toString()}
                        className="TabsOne"
                        activeKey={this.state.activeTabKey}
                        onSelect={(k) => this.setState({ activeTabKey: k })}
                      >
                        <Tab
                          eventKey="Send123"
                          justify={true.toString()}
                          id="TabsTwo"
                          style={{ color: "red" }}
                          className="cursor-pointer py-4 px-8 bg-red-background border border-red-intermediate flex flex-grow"
                          title="Edit data"
                        >
                          <Row className="divstyle" style={{ padding: "5px" }}>
                            <Row>
                              <Form>
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Project Id
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <select
                                      disabled
                                      className="form-select"
                                      name="projectid"
                                      value={this.state.projectid}
                                      onChange={this.handleprojectidChange}
                                    >
                                      <option defaultValue>
                                        Select Project Id
                                      </option>
                                      {this.state.itprojectstable.map(
                                        (api, index, idx) => (
                                          <option
                                            key={index}
                                            value={api.itprojectstable_Id}
                                          >
                                            {api.projectName}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Task ID
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Form.Control
                                      type="text"
                                      disabled
                                      onChange={this.handletaskNameChange}
                                      className="form-control"
                                      name="ittaskstable_Id"
                                      value={this.state.ittaskstable_Id}
                                      required="required"
                                      placeholder="Enter TaskId"
                                    />
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Project Name
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <select
                                      className="form-select"
                                      name="projectName"
                                      value={this.state.projectName}
                                      onChange={this.handleprojectNameChange}
                                    >
                                      <option defaultValue>
                                        Select Project Name
                                      </option>
                                      {this.state.itprojectstable.map(
                                        (api, index, idx) => (
                                          <option
                                            key={index}
                                            value={api.projectName}
                                          >
                                            {api.projectName}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Color Code
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Form.Control
                                      type="color"
                                      onChange={this.handlecolorCodeChange}
                                      className="form-control"
                                      name="colorCode"
                                      value={this.state.colorCode}
                                      required="required"
                                      //  placeholder="Enter Dummy One"
                                    />
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    {/* <Form.Label style={{ paddingTop: "8px" }}>
                                        Color Code Format
                                      </Form.Label> */}
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Form.Control
                                      disabled
                                      type="text"
                                      onChange={this.handlecolorCodeChange}
                                      className="form-control"
                                      name="colorCode"
                                      value={this.state.colorCode}
                                      required="required"
                                      //  placeholder="Enter Dummy One"
                                    />
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      User Story
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <select
                                      className="form-select"
                                      name="userStory"
                                      value={this.state.userStory}
                                      onChange={this.handleuserStoryChange}
                                    >
                                      <option defaultValue>
                                        Select UserStory
                                      </option>
                                      {this.state.userstoriestable.map(
                                        (api, index, idx) => (
                                          <option
                                            key={index}
                                            value={api.userStory}
                                          >
                                            {api.userStory}
                                          </option>
                                        ),
                                      )}
                                    </select>
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Task Name
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Form.Control
                                      as="textarea"
                                      rows={3}
                                      onChange={this.handletaskNameChange}
                                      className="form-control"
                                      name="taskName"
                                      value={this.state.taskName}
                                      required="required"
                                      placeholder="Enter Task Name"
                                    />
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Task Description
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Form.Control
                                      as="textarea"
                                      rows={4}
                                      onChange={
                                        this.handletaskDescriptionChange
                                      }
                                      className="form-control"
                                      name="taskDescription"
                                      value={this.state.taskDescription}
                                      required="required"
                                      placeholder="Enter Task Description"
                                    />
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Assigned To
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Form.Select
                                      type="text"
                                      onChange={this.handleassignedToChange}
                                      className="form-select"
                                      name="assignedTo"
                                      value={this.state.assignedTo}
                                      required="required"
                                      placeholder="Enter AssignedTo"
                                    >
                                      <option defaultValue>
                                        Select Project Owner
                                      </option>
                                      {this.state.employees.map(
                                        (api, index, idx) => (
                                          <option
                                            key={index}
                                            value={api.employees_Id}
                                          >
                                            {api.fName}&nbsp;{api.lName}
                                          </option>
                                        ),
                                      )}
                                    </Form.Select>
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Stage Name
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Form.Select
                                      type="text"
                                      onChange={this.handlestagenameToChange}
                                      className="form-select"
                                      name="stagename"
                                      value={this.state.stagename}
                                      required="required"
                                    >
                                      <option defaultValue>
                                        Select Project Owner
                                      </option>
                                      {this.state.leadstages.map(
                                        (api, index, idx) => (
                                          <option
                                            key={index}
                                            value={api.leadstages_Id}
                                          >
                                            {api.stageName}
                                          </option>
                                        ),
                                      )}
                                    </Form.Select>
                                  </Col>
                                </Row>

                                <br />
                                <Row className="d-flex">
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Estimated Task Time
                                    </Form.Label>
                                  </Col>
                                  <Col
                                    lg="8"
                                    md="8"
                                    className="d-flex m-0"
                                    style={{
                                      paddingTop: "8px",
                                      margin: "0px",
                                      //padding: "0px",
                                    }}
                                  >
                                    <Form.Group className="d-flex">
                                      <Form.Select
                                        className="form-control"
                                        name="hours"
                                        value={this.state.hours}
                                        onChange={this.handleTimeChange}
                                      >
                                        <option value="">HH</option>
                                        {[...Array(24).keys()].map((hour) => (
                                          <option
                                            key={hour}
                                            value={hour
                                              .toString()
                                              .padStart(2, "0")}
                                          >
                                            {hour.toString().padStart(2, "0")}
                                          </option>
                                        ))}
                                      </Form.Select>
                                      &nbsp;
                                      <Form.Select
                                        name="minutes"
                                        value={this.state.minutes}
                                        onChange={this.handleTimeChange}
                                      >
                                        <option value="">MM</option>
                                        {[
                                          0, 1, 2, 3, 4, 5, 10, 15, 20, 25, 30,
                                          45, 50, 55,
                                        ].map((min) => (
                                          <option
                                            key={min}
                                            value={min
                                              .toString()
                                              .padStart(2, "0")}
                                          >
                                            {min.toString().padStart(2, "0")}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4"></Col>
                                  <Col lg="8" md="8 ">
                                    <Form.Control
                                      type="text"
                                      value={this.state.estimatedTaskTime}
                                      readOnly
                                      placeholder="HH:MM"
                                    />
                                  </Col>
                                </Row>
                                <br />
                                <Row className="d-flex">
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Actual Task Time
                                    </Form.Label>
                                  </Col>
                                  <Col
                                    lg="8"
                                    md="8"
                                    className="d-flex m-0"
                                    style={{
                                      paddingTop: "8px",
                                      margin: "0px",
                                    }}
                                  >
                                    <Form.Group className="d-flex">
                                      <Form.Select
                                        className="form-control"
                                        name="actualHours"
                                        value={this.state.actualHours}
                                        onChange={this.handleActualTimeChange}
                                      >
                                        <option value="">HH</option>
                                        {[...Array(24).keys()].map((hour) => (
                                          <option
                                            key={hour}
                                            value={hour
                                              .toString()
                                              .padStart(2, "0")}
                                          >
                                            {hour.toString().padStart(2, "0")}
                                          </option>
                                        ))}
                                      </Form.Select>
                                      &nbsp;
                                      <Form.Select
                                        name="actualMinutes"
                                        value={this.state.actualMinutes}
                                        onChange={this.handleActualTimeChange}
                                      >
                                        <option value="">MM</option>
                                        {[
                                          0, 1, 2, 3, 4, 5, 10, 15, 20, 25, 30,
                                          45, 50, 55,
                                        ].map((min) => (
                                          <option
                                            key={min}
                                            value={min
                                              .toString()
                                              .padStart(2, "0")}
                                          >
                                            {min.toString().padStart(2, "0")}
                                          </option>
                                        ))}
                                      </Form.Select>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4"></Col>
                                  <Col lg="8" md="8 ">
                                    <Form.Control
                                      type="text"
                                      value={this.state.actualTaskTime}
                                      readOnly
                                      placeholder="HH:MM"
                                    />
                                  </Col>
                                </Row>
                                <br />
                                <Row>
                                  <Col lg="4" md="4">
                                    <Form.Label style={{ paddingTop: "8px" }}>
                                      Dependency Task ID
                                    </Form.Label>
                                  </Col>
                                  <Col lg="8" md="8">
                                    <Form.Select
                                      type="text"
                                      onChange={
                                        this.handledependencyTaskIDChange
                                      }
                                      className="form-control"
                                      name="dependencyTaskID"
                                      value={this.state.dependencyTaskID}
                                      required="required"
                                      placeholder="Enter Dependency Task ID"
                                    >
                                      <option defaultValue>Select Task</option>
                                      {this.state.ittaskstable.map(
                                        (api, index, idx) => (
                                          <option
                                            key={index}
                                            value={api.ittaskstable_Id}
                                          >
                                            {api.taskName}
                                            {/* {api.fName}&nbsp;{api.lName} */}
                                          </option>
                                        ),
                                      )}
                                    </Form.Select>
                                  </Col>
                                  <Col className="d-flex justify-content-end">
                                    <Button
                                      className="button"
                                      variant="success"
                                      onClick={this.IttaskstableupdateHandler}
                                      style={{
                                        marginTop: "20px",
                                      }}
                                    >
                                      Update
                                    </Button>
                                  </Col>
                                </Row>
                                {/* tableContent */}
                              </Form>
                            </Row>
                          </Row>
                        </Tab>
                        <Tab
                          eventKey="Receive"
                          justify="true"
                          id="TabsTwo"
                          style={{ color: "red" }}
                          className="cursor-pointer py-4 px-8 bg-red-background border border-red-intermediate flex flex-grow"
                          title="Notes"
                        >
                          <div style={{ padding: "5px" }}>
                            <div>
                              <DataTable
                                data={
                                  this.state.filteredData
                                    ? this.state.filteredData.slice(
                                        (this.state.currentPage - 1) *
                                          this.state.itemsPerPage,
                                        this.state.currentPage *
                                          this.state.itemsPerPage,
                                      )
                                    : []
                                }
                                columns={this.state.tableClms}
                                pagination
                                paginationServer
                                paginationTotalRows={
                                  this.state.filteredData
                                    ? this.state.filteredData.length
                                    : 0
                                }
                                onChangeRowsPerPage={this.handlePerRowsChange}
                                onChangePage={this.handlePageChange}
                                paginationRowsPerPageOptions={[
                                  100, 200, 300, 400, 500, 600, 700, 800, 900,
                                  1000,
                                ]}
                                paginationPerPage={100}
                                keyField="tasknotes_Id"
                                className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                              />
                            </div>
                          </div>
                          <hr />
                          <div>
                            <Row>
                              <Col lg="4" md="2" sm="2"></Col>
                              <Col>
                                <Form>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Notes
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="textarea"
                                        rows={4}
                                        onChange={this.handletaskNotesChange}
                                        className="form-control"
                                        name="taskNotes"
                                        value={this.state.taskNotes}
                                        required="required"
                                        placeholder="Enter Notes"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  {/* tableContent */}
                                </Form>
                                <br />
                                <Row>
                                  <Col
                                    className="d-flex justify-content-end"
                                    style={{ marginRight: "50px" }}
                                  >
                                    <Button
                                      className="button"
                                      variant="success"
                                      onClick={this.TasknotessubmitHandler}
                                      style={{
                                        marginTop: "20px",
                                      }}
                                    >
                                      Save
                                    </Button>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </div>
                        </Tab>
                        <Tab
                          eventKey="Cases"
                          justify="true"
                          id="TabsTwo"
                          style={{ color: "red" }}
                          className="cursor-pointer py-4 px-8 bg-red-background border border-red-intermediate flex flex-grow"
                          title="Test Cases"
                        >
                          <div style={{ padding: "5px" }}>
                            <div>
                              <Row>
                                <Col>
                                  <Button
                                    style={{ float: "right" }}
                                    variant="success"
                                    onClick={() =>
                                      this.setState({
                                        showtestcaseModal: true,
                                        testcase_title: "",
                                        testcase_description: "",
                                      })
                                    }
                                  >
                                    Add Test Cases
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                            <br />
                            <hr />
                            <div>
                              <div>
                                <Table
                                  className="table table-bordered table-hover"
                                  style={{ marginLeft: "0px" }}
                                >
                                  <thead>
                                    <tr>
                                      <th>S.No</th>
                                      <th>Title</th>
                                      <th>Description</th>
                                      <th>Status</th>
                                      <th>Remarks</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredTestCases.length > 0 ? (
                                      filteredTestCases.map((test, index) => {
                                        const title = test.testcase_title || "";
                                        const desc =
                                          test.testcase_description || "";
                                        const remarks =
                                          test.failurereason || "";

                                        const isTitleExpanded =
                                          this.state.expandedRows?.[
                                            `title-${test.ittaskstestcases_Id}`
                                          ];
                                        const isDescExpanded =
                                          this.state.expandedRows?.[
                                            `desc-${test.ittaskstestcases_Id}`
                                          ];
                                        const isRemarksExpanded =
                                          this.state.expandedRows?.[
                                            `remarks-${test.ittaskstestcases_Id}`
                                          ];

                                        return (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                              <span>
                                                {isTitleExpanded
                                                  ? title
                                                  : title.slice(0, 10)}
                                              </span>
                                              {title.length > 10 && (
                                                <span
                                                  onClick={() =>
                                                    this.setState(
                                                      (prevState) => ({
                                                        expandedRows: {
                                                          ...prevState.expandedRows,
                                                          [`title-${test.ittaskstestcases_Id}`]:
                                                            !isTitleExpanded,
                                                        },
                                                      }),
                                                      () =>
                                                        this.IttaskstestcaseseditHandler(
                                                          test,
                                                        ),
                                                    )
                                                  }
                                                  style={{
                                                    color: "#007bff",
                                                    cursor: "pointer",
                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  {isTitleExpanded
                                                    ? " Show less"
                                                    : " Show more"}
                                                </span>
                                              )}
                                            </td>
                                            <td>
                                              <span>
                                                {isDescExpanded
                                                  ? desc
                                                  : desc.slice(0, 10)}
                                              </span>
                                              {desc.length > 10 && (
                                                <span
                                                  onClick={() =>
                                                    this.setState(
                                                      (prevState) => ({
                                                        expandedRows: {
                                                          ...prevState.expandedRows,
                                                          [`desc-${test.ittaskstestcases_Id}`]:
                                                            !isDescExpanded,
                                                        },
                                                      }),
                                                      () =>
                                                        this.IttaskstestcaseseditHandler(
                                                          test,
                                                        ),
                                                    )
                                                  }
                                                  style={{
                                                    color: "#007bff",
                                                    cursor: "pointer",
                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  {isDescExpanded
                                                    ? " Show less"
                                                    : " Show more"}
                                                </span>
                                              )}
                                            </td>
                                            <td>{test.status}</td>
                                            <td>
                                              <span>
                                                {isRemarksExpanded
                                                  ? remarks
                                                  : remarks.slice(0, 10)}
                                              </span>
                                              {remarks.length > 10 && (
                                                <span
                                                  onClick={() =>
                                                    this.setState(
                                                      (prevState) => ({
                                                        expandedRows: {
                                                          ...prevState.expandedRows,
                                                          [`remarks-${test.ittaskstestcases_Id}`]:
                                                            !isRemarksExpanded,
                                                        },
                                                      }),
                                                      () =>
                                                        this.IttaskstestcaseseditHandler(
                                                          test,
                                                        ),
                                                    )
                                                  }
                                                  style={{
                                                    color: "#007bff",
                                                    cursor: "pointer",
                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  {isRemarksExpanded
                                                    ? " Show less"
                                                    : " Show more"}
                                                </span>
                                              )}
                                            </td>
                                            <td>
                                              <Button
                                                className="bi bi-pen btn btn-primary"
                                                onClick={() =>
                                                  this.IttaskstestcaseseditHandler(
                                                    test,
                                                  )
                                                }
                                              ></Button>
                                              {this.isCurrentUserReportingManager() && (
                                                <Button
                                                  style={{
                                                    padding: "8px 15px",
                                                  }}
                                                  variant="danger"
                                                  onClick={() =>
                                                    this.handleDelete(test)
                                                  }
                                                  className="bi bi-trash btn btn-danger m-1"
                                                />
                                              )}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan="13">No Records</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </div>
                            </div>
                          </div>
                          <hr />
                          <div>
                            <Modal
                              show={this.state.showtestcaseModal}
                              onHide={() =>
                                this.setState({ showtestcaseModal: false })
                              }
                              size="lg"
                            >
                              <Modal.Header>Add Test Cases</Modal.Header>
                              <Modal.Body>
                                <Row className="divstyle">
                                  <Row>
                                    <Form>
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            Test case Title
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            type="text"
                                            onChange={
                                              this.handletestcase_titleChange
                                            }
                                            name="testcase_title"
                                            value={this.state.testcase_title}
                                            placeholder="Enter Testcase Title"
                                            required
                                          />
                                        </Col>
                                      </Row>
                                      <br />
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            Test case Description
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            as="textarea"
                                            rows={3}
                                            onChange={
                                              this
                                                .handletestcase_descriptionChange
                                            }
                                            className="form-control"
                                            name="testcase_description"
                                            value={
                                              this.state.testcase_description
                                            }
                                            required="required"
                                            placeholder="Enter Testcase Description"
                                          />
                                        </Col>
                                      </Row>
                                      <br />
                                      {/* Auto-generated form content with validation */}
                                    </Form>
                                  </Row>
                                </Row>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  variant="secondary"
                                  onClick={() =>
                                    this.setState({ showtestcaseModal: false })
                                  }
                                >
                                  Close
                                </Button>
                                <Button
                                  className="button"
                                  variant="primary"
                                  onClick={this.IttaskstestcasessubmitHandler}
                                >
                                  Submit
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </div>
                          <br />
                          <div>
                            <Modal
                              show={this.state.showModal}
                              onHide={() => this.setState({ showModal: false })}
                              size="lg"
                            >
                              <Modal.Header closeButton>
                                <Modal.Title>Update Test Cases</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Test case Title
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handletestcase_titleChange
                                        }
                                        name="testcase_title"
                                        value={this.state.testcase_title}
                                        placeholder="Enter Testcase Title"
                                        required
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Test case Description
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="textarea"
                                        rows={3}
                                        onChange={
                                          this.handletestcase_descriptionChange
                                        }
                                        name="testcase_description"
                                        value={this.state.testcase_description}
                                        placeholder="Enter Description"
                                        required
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label>Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Select
                                        name="status"
                                        value={this.state.status}
                                        onChange={this.handlestatusChange}
                                      >
                                        <option defaultValue>
                                          Select Status
                                        </option>
                                        {this.state.testcasestatusmaster.map(
                                          (api, index) => (
                                            <option
                                              key={index}
                                              value={api.pending}
                                            >
                                              {api.pending}
                                            </option>
                                          ),
                                        )}
                                      </Form.Select>
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label>Remarks</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        as="textarea"
                                        rows={3}
                                        onChange={
                                          this.handlefailurereasonChange
                                        }
                                        name="failurereason"
                                        value={this.state.failurereason}
                                        placeholder="Enter Remarks"
                                        required
                                      />
                                    </Col>
                                  </Row>
                                </Form>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button
                                  variant="secondary"
                                  onClick={() =>
                                    this.setState({ showModal: false })
                                  }
                                >
                                  Close
                                </Button>
                                <Button
                                  variant="primary"
                                  onClick={this.IttaskstestcasesupdateHandler}
                                >
                                  Update
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        </Tab>
                        <Tab
                          eventKey="deployment"
                          justify="true"
                          id="TabsThree"
                          style={{ color: "red" }}
                          className="cursor-pointer py-4 px-8 bg-red-background border border-red-intermediate flex flex-grow"
                          title="Deployment Details"
                        >
                          <div style={{ padding: "5px" }}>
                            <div>
                              <Row>
                                <Col>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          DB Script
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="textarea"
                                          rows={3}
                                          onChange={this.handledbScriptChange}
                                          className="form-control"
                                          name="dbScript"
                                          value={this.state.dbScript}
                                          required="required"
                                          placeholder="Enter DB Script"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Files
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="textarea"
                                          rows={3}
                                          onChange={this.handlefilesChange}
                                          className="form-control"
                                          name="files"
                                          value={this.state.files}
                                          required="required"
                                          placeholder="Enter Files"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Code Git Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select
                                          className="form-select"
                                          name="tableName"
                                          onChange={
                                            this.handlecodeGitStatusChange
                                          }
                                        >
                                          <option defaultValue>
                                            {" "}
                                            Select Code Git Status{" "}
                                          </option>
                                          {this.state.yes_no.map(
                                            (api, index, idx) => (
                                              <option
                                                key={index}
                                                value={api.value}
                                              >
                                                {" "}
                                                {api.value}{" "}
                                              </option>
                                            ),
                                          )}
                                        </select>
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Location
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          as="textarea"
                                          rows={3}
                                          onChange={this.handlelocationChange}
                                          className="form-control"
                                          name="location"
                                          value={this.state.location}
                                          required="required"
                                          placeholder="Enter Location"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col className="d-flex justify-content-end">
                                        <Button
                                          className="button"
                                          variant="success"
                                          onClick={
                                            this.DeploymentstatussubmitHandler
                                          }
                                          style={{
                                            marginTop: "20px",
                                          }}
                                        >
                                          Save
                                        </Button>
                                      </Col>
                                    </Row>
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Col>
                              </Row>
                            </div>
                            <hr />
                            <div>
                              <Table
                                className="table table-bordered table-hover"
                                style={{ marginLeft: "0px" }}
                              >
                                <thead>
                                  <tr>
                                    <th>S.No</th>
                                    <th>Files</th>
                                    <th>Location</th>
                                    <th>DB Script</th>
                                    <th>Git Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.filteredDeploymentStatus &&
                                  this.state.filteredDeploymentStatus.length >
                                    0 ? (
                                    this.state.filteredDeploymentStatus.map(
                                      (test, index) => {
                                        return (
                                          <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{test.files}</td>
                                            <td>{test.location}</td>
                                            <td>{test.dbScript}</td>
                                            <td>{test.codeGitStatus}</td>
                                          </tr>
                                        );
                                      },
                                    )
                                  ) : (
                                    <tr>
                                      <td colSpan="5">No Records</td>
                                    </tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </Tab>
                      </Tabs>
                    </Offcanvas.Body>
                  </Offcanvas>
                )}
                <br />
                {this.state.isEditingView && (
                  // View Offcanvas
                  <Offcanvas
                    show={this.state.isEditingView}
                    // onHide={() => this.setState({ isEditing: false })}
                    onHide={this.handleOffcanvasviewClose}
                    {...this.props}
                    style={{ width: "800px" }}
                    placement="end"
                  >
                    <Offcanvas.Header closeButton>
                      <Offcanvas.Title>View IT Tasks </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                      <Tabs
                        defaultActiveKey="Send123"
                        id="justify-tab-example"
                        justify={true.toString()}
                        className="TabsOne"
                      >
                        <Tab
                          eventKey="Send123"
                          justify={true.toString()}
                          id="TabsTwo"
                          style={{ color: "red" }}
                          className="cursor-pointer py-4 px-8 bg-red-background border border-red-intermediate flex flex-grow"
                          title="Edit data"
                        >
                          <Row className="divstyle" style={{ padding: "5px" }}>
                            <Form>
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Project Id
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <select
                                    disabled
                                    className="form-select"
                                    name="projectid"
                                    value={this.state.projectid}
                                    onChange={this.handleprojectidChange}
                                  >
                                    <option defaultValue>
                                      Select Project Id
                                    </option>
                                    {this.state.itprojectstable.map(
                                      (api, index, idx) => (
                                        <option
                                          key={index}
                                          value={api.itprojectstable_Id}
                                        >
                                          {api.projectName}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Task ID
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    type="text"
                                    disabled
                                    onChange={this.handletaskNameChange}
                                    className="form-control"
                                    name="ittaskstable_Id"
                                    value={this.state.ittaskstable_Id}
                                    required="required"
                                    placeholder="Enter TaskId"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Project Name
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <select
                                    className="form-select"
                                    name="projectName"
                                    value={this.state.projectName}
                                    disabled
                                    onChange={this.handleprojectNameChange}
                                  >
                                    <option defaultValue>
                                      Select Project Name
                                    </option>
                                    {this.state.itprojectstable.map(
                                      (api, index, idx) => (
                                        <option
                                          key={index}
                                          value={api.projectName}
                                        >
                                          {api.projectName}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Color Code
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    type="color"
                                    onChange={this.handlecolorCodeChange}
                                    className="form-control"
                                    name="colorCode"
                                    value={this.state.colorCode}
                                    required="required"
                                    //  placeholder="Enter Dummy One"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  {/* <Form.Label style={{ paddingTop: "8px" }}>
                                        Color Code Format
                                      </Form.Label> */}
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    type="text"
                                    onChange={this.handlecolorCodeChange}
                                    className="form-control"
                                    name="colorCode"
                                    value={this.state.colorCode}
                                    required="required"
                                    //  placeholder="Enter Dummy One"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    User Story
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <select
                                    disabled
                                    className="form-select"
                                    name="userStory"
                                    value={this.state.userStory}
                                    onChange={this.handleuserStoryChange}
                                  >
                                    <option defaultValue>
                                      Select UserStory
                                    </option>
                                    {this.state.userstoriestable.map(
                                      (api, index, idx) => (
                                        <option
                                          key={index}
                                          value={api.userStory}
                                        >
                                          {api.userStory}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Task Name
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    as="textarea"
                                    rows={3}
                                    onChange={this.handletaskNameChange}
                                    className="form-control"
                                    name="taskName"
                                    value={this.state.taskName}
                                    required="required"
                                    placeholder="Enter Task Name"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Task Description
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    as="textarea"
                                    rows={4}
                                    disabled
                                    onChange={this.handletaskDescriptionChange}
                                    className="form-control"
                                    name="taskDescription"
                                    value={this.state.taskDescription}
                                    required="required"
                                    placeholder="Enter Task Description"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Assigned To
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Select
                                    type="text"
                                    disabled
                                    onChange={this.handleassignedToChange}
                                    className="form-select"
                                    name="assignedTo"
                                    value={this.state.assignedTo}
                                    required="required"
                                    placeholder="Enter AssignedTo"
                                  >
                                    <option defaultValue>
                                      Select Project Owner
                                    </option>
                                    {this.state.employees.map(
                                      (api, index, idx) => (
                                        <option
                                          key={index}
                                          value={api.employees_Id}
                                        >
                                          {api.fName}&nbsp;{api.lName}
                                        </option>
                                      ),
                                    )}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Stage Name
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Select
                                    type="text"
                                    disabled
                                    onChange={this.handlestagenameToChange}
                                    className="form-select"
                                    name="stagename"
                                    value={this.state.stagename}
                                    required="required"
                                  >
                                    <option defaultValue>
                                      Select Project Owner
                                    </option>
                                    {this.state.leadstages.map(
                                      (api, index, idx) => (
                                        <option
                                          key={index}
                                          value={api.leadstages_Id}
                                        >
                                          {api.stageName}
                                        </option>
                                      ),
                                    )}
                                  </Form.Select>
                                </Col>
                              </Row>
                              <br />
                              <Row className="d-flex">
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Estimated Task Time
                                  </Form.Label>
                                </Col>
                                <Col
                                  lg="8"
                                  md="8"
                                  className="d-flex m-0"
                                  style={{
                                    paddingTop: "8px",
                                    margin: "0px",
                                    // padding: "0px",
                                  }}
                                >
                                  <Form.Group className="d-flex">
                                    <Form.Select
                                      disabled
                                      className="form-control"
                                      name="hours"
                                      value={this.state.hours}
                                      onChange={this.handleTimeChange}
                                    >
                                      <option value="">HH</option>
                                      {[...Array(24).keys()].map((hour) => (
                                        <option
                                          key={hour}
                                          value={hour
                                            .toString()
                                            .padStart(2, "0")}
                                        >
                                          {hour.toString().padStart(2, "0")}
                                        </option>
                                      ))}
                                    </Form.Select>
                                    &nbsp;
                                    <Form.Select
                                      disabled
                                      name="minutes"
                                      value={this.state.minutes}
                                      onChange={this.handleTimeChange}
                                    >
                                      <option value="">MM</option>
                                      {[
                                        0, 1, 2, 3, 4, 5, 10, 15, 20, 25, 30,
                                        45, 50, 55,
                                      ].map((min) => (
                                        <option
                                          key={min}
                                          value={min
                                            .toString()
                                            .padStart(2, "0")}
                                        >
                                          {min.toString().padStart(2, "0")}
                                        </option>
                                      ))}
                                    </Form.Select>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4"></Col>
                                <Col lg="8" md="8 ">
                                  <Form.Control
                                    disabled
                                    type="text"
                                    value={this.state.estimatedTaskTime}
                                    readOnly
                                    placeholder="HH:MM"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Dependency Task ID
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Select
                                    type="text"
                                    disabled
                                    onChange={this.handledependencyTaskIDChange}
                                    className="form-control"
                                    name="dependencyTaskID"
                                    value={this.state.dependencyTaskID}
                                    required="required"
                                    placeholder="Enter Dependency Task ID"
                                  >
                                    <option defaultValue>Select Task</option>
                                    {this.state.ittaskstable.map(
                                      (api, index, idx) => (
                                        <option
                                          key={index}
                                          value={api.ittaskstable_Id}
                                        >
                                          {api.taskName}
                                          {/* {api.fName}&nbsp;{api.lName} */}
                                        </option>
                                      ),
                                    )}
                                  </Form.Select>
                                </Col>
                                <Col className="d-flex justify-content-end">
                                  <Button
                                    closeButton
                                    className="button"
                                    variant="success"
                                    //   onClick={this.handleOffcanvasviewClose}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Back
                                  </Button>
                                </Col>
                              </Row>
                              {/* tableContent */}
                            </Form>
                          </Row>
                        </Tab>
                        <Tab
                          eventKey="Receive"
                          justify="true"
                          id="TabsTwo"
                          style={{ color: "red" }}
                          className="cursor-pointer py-4 px-8 bg-red-background border border-red-intermediate flex flex-grow"
                          title="History"
                        >
                          <Row style={{ padding: "5px" }}>
                            <Form>
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Task ID
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    type="text"
                                    onChange={this.handletaskIDChange}
                                    className="form-control"
                                    name="taskID"
                                    value={this.state.taskID}
                                    required="required"
                                    placeholder="Enter TaskID"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Moved From Stage
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    type="text"
                                    onChange={this.handlemovedFromStageChange}
                                    className="form-control"
                                    name="movedFromStage"
                                    value={this.state.movedFromStage}
                                    required="required"
                                    placeholder="Enter MovedFromStage"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Moved To Stage
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    type="text"
                                    onChange={this.handlemovedToStageChange}
                                    className="form-control"
                                    name="movedToStage"
                                    value={this.state.movedToStage}
                                    required="required"
                                    placeholder="Enter MovedToStage"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Moved By
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    type="text"
                                    onChange={this.handlemovedByChange}
                                    className="form-control"
                                    name="movedBy"
                                    value={this.state.movedBy}
                                    required="required"
                                    placeholder="Enter MovedBy"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Moved At
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    type="text"
                                    onChange={this.handlemovedAtChange}
                                    className="form-control"
                                    name="movedAt"
                                    value={this.state.movedAt}
                                    required="required"
                                    placeholder="Enter MovedAt"
                                  />
                                </Col>
                              </Row>
                              <br />
                              <Row>
                                <Col lg="4" md="4">
                                  <Form.Label style={{ paddingTop: "8px" }}>
                                    Time In Stage
                                  </Form.Label>
                                </Col>
                                <Col lg="8" md="8">
                                  <Form.Control
                                    disabled
                                    type="text"
                                    onChange={this.handletimeInStageChange}
                                    className="form-control"
                                    name="timeInStage"
                                    value={this.state.timeInStage}
                                    required="required"
                                    placeholder="Enter TimeInStage"
                                  />
                                </Col>
                              </Row>
                              <br />

                              {/* tableContent */}
                            </Form>
                          </Row>
                        </Tab>
                      </Tabs>
                    </Offcanvas.Body>
                  </Offcanvas>
                )}

                <Offcanvas
                  //Add New task
                  show={showtwoOffcanvas}
                  onHide={this.handletwoCloseOffcanvas}
                  placement="end"
                  style={{ width: "800px" }}
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add New Task</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <Row className="divstyle">
                      <Row>
                        <Form>
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Project Id
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <select
                                className="form-select"
                                name="projectid"
                                value={this.state.projectid}
                                onChange={this.handleprojectidChange}
                              >
                                <option defaultValue>Select Project Id</option>
                                {this.state.itprojectstable.map(
                                  (api, index, idx) => (
                                    <option
                                      key={index}
                                      value={api.itprojectstable_Id}
                                    >
                                      {api.projectName}
                                    </option>
                                  ),
                                )}
                              </select>
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Project Name
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <select
                                disabled
                                className="form-select"
                                name="projectName"
                                value={this.state.projectName}
                                onChange={this.handleprojectNameChange}
                              >
                                <option defaultValue>
                                  Select Project Name
                                </option>
                                {this.state.itprojectstable.map(
                                  (api, index, idx) => (
                                    <option key={index} value={api.projectName}>
                                      {api.projectName}
                                    </option>
                                  ),
                                )}
                              </select>
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Color Code
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                type="color"
                                onChange={this.handlecolorCodeChange}
                                className="form-control"
                                name="colorCode"
                                value={this.state.colorCode}
                                required="required"
                                //  placeholder="Enter Dummy One"
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4">
                              {/* <Form.Label style={{ paddingTop: "8px" }}>
                                        Color Code Format
                                      </Form.Label> */}
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                disabled
                                type="text"
                                onChange={this.handlecolorCodeChange}
                                className="form-control"
                                name="colorCode"
                                value={this.state.colorCode}
                                required="required"
                                //  placeholder="Enter Dummy One"
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                User Story
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <select
                                className="form-select"
                                name="userStory"
                                value={this.state.userStory}
                                onChange={this.handleuserStoryChange}
                              >
                                <option defaultValue>Select UserStory</option>
                                {this.state.filteredUserStories.map(
                                  (api, index, idx) => (
                                    <option key={index} value={api.userStory}>
                                      {api.userStory}
                                    </option>
                                  ),
                                )}
                              </select>
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Task Name
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                as="textarea"
                                rows={3}
                                onChange={this.handletaskNameChange}
                                className="form-control"
                                name="taskName"
                                value={this.state.taskName}
                                required="required"
                                placeholder="Enter Task Name"
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Task Description
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Control
                                as="textarea"
                                rows={4}
                                onChange={this.handletaskDescriptionChange}
                                className="form-control"
                                name="taskDescription"
                                value={this.state.taskDescription}
                                required="required"
                                placeholder="Enter Task Description"
                              />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Assigned To
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Select
                                type="text"
                                onChange={this.handleassignedToChange}
                                className="form-select"
                                name="assignedTo"
                                value={this.state.assignedTo}
                                required="required"
                                placeholder="Enter AssignedTo"
                              >
                                <option defaultValue>Select Task Owner</option>
                                {this.state.employees.map((api, index, idx) => (
                                  <option key={index} value={api.employees_Id}>
                                    {api.fName}&nbsp;{api.lName}
                                  </option>
                                ))}
                              </Form.Select>
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Stage Name
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Select
                                type="text"
                                onChange={this.handlestagenameToChange}
                                className="form-select"
                                name="stagename"
                                value={this.state.stagename}
                                required="required"
                              >
                                <option defaultValue>Select Stage</option>
                                {this.state.leadstages.map(
                                  (api, index, idx) => (
                                    <option
                                      key={index}
                                      value={api.leadstages_Id}
                                    >
                                      {api.stageName}
                                    </option>
                                  ),
                                )}
                              </Form.Select>
                            </Col>
                          </Row>
                          <br />
                          <Row className="d-flex">
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Estimated Task Time
                              </Form.Label>
                            </Col>
                            <Col
                              lg="8"
                              md="8"
                              className="d-flex m-0"
                              style={{
                                paddingTop: "8px",
                                margin: "0px",
                                //padding: "0px",
                              }}
                            >
                              <Form.Group className="d-flex">
                                <Form.Select
                                  className="form-control"
                                  name="hours"
                                  value={this.state.hours}
                                  onChange={this.handleTimeChange}
                                >
                                  <option value="">HH</option>
                                  {[...Array(24).keys()].map((hour) => (
                                    <option
                                      key={hour}
                                      value={hour.toString().padStart(2, "0")}
                                    >
                                      {hour.toString().padStart(2, "0")}
                                    </option>
                                  ))}
                                </Form.Select>
                                &nbsp;
                                <Form.Select
                                  name="minutes"
                                  value={this.state.minutes}
                                  onChange={this.handleTimeChange}
                                >
                                  <option value="">MM</option>
                                  {[
                                    0, 1, 2, 3, 4, 5, 10, 15, 20, 25, 30, 45,
                                    50, 55,
                                  ].map((min) => (
                                    <option
                                      key={min}
                                      value={min.toString().padStart(2, "0")}
                                    >
                                      {min.toString().padStart(2, "0")}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col lg="4" md="4"></Col>
                            <Col lg="8" md="8 ">
                              <Form.Control
                                type="text"
                                value={this.state.estimatedTaskTime}
                                readOnly
                                placeholder="HH:MM"
                              />
                            </Col>
                          </Row>
                          <br />

                          <Row>
                            <Col lg="4" md="4">
                              <Form.Label style={{ paddingTop: "8px" }}>
                                Dependency Task ID
                              </Form.Label>
                            </Col>
                            <Col lg="8" md="8">
                              <Form.Select
                                type="text"
                                onChange={this.handledependencyTaskIDChange}
                                className="form-control"
                                name="dependencyTaskID"
                                value={this.state.dependencyTaskID}
                                required="required"
                                placeholder="Enter Dependency Task ID"
                              >
                                <option defaultValue>Select Task</option>
                                {this.state.filteredDependencyTasks.map(
                                  (api, index, idx) => (
                                    <option key={index} value={api.taskName}>
                                      {api.taskName}
                                      {/* {api.fName}&nbsp;{api.lName} */}
                                    </option>
                                  ),
                                )}
                              </Form.Select>
                            </Col>
                          </Row>

                          <br />
                          {/* tableContent */}
                        </Form>
                      </Row>
                    </Row>
                    <Row>
                      <Col
                        className="d-flex justify-content-end"
                        style={{ marginRight: "50px" }}
                      >
                        <Button
                          className="button"
                          variant="success"
                          onClick={this.IttaskstablesubmitHandler}
                          style={{
                            marginTop: "20px",
                          }}
                        >
                          Save
                        </Button>
                      </Col>
                    </Row>
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
            ))}
        </div>

        {(() => {
          const stage99Column = this.state.columns.find(
            (col) => col.stageOrder === 99,
          );
          const isDraggingCard = this.state.draggedItemType === "card";
          const showArchive = this.state.showStage99;

          if (stage99Column && isDraggingCard && showArchive) {
            return (
              <div
                className="archive-drop-zone"
                onDragOver={this.handleCardDragOver}
                onDrop={() => this.handleCardDrop(stage99Column.id)}
                style={{
                  position: "fixed",
                  bottom: "40px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "300px",
                  height: "80px",
                  border: "2px solid #000",
                  borderRadius: "0px",
                  backgroundColor: "rgb(0 0 0 / 60%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                  transition:
                    "background-color 0.3s ease, border-color 0.3s ease",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  pointerEvents: showArchive ? "auto" : "none",
                }}
                onDragEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(255, 107, 107, 0.2)";
                  e.currentTarget.style.borderColor = "#ff5252";
                }}
                onDragLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "rgba(255, 107, 107, 0.1)";
                  e.currentTarget.style.borderColor = "#ff6b6b";
                }}
              >
                {/* <div style={{ textAlign: "center", color: "#FFF", fontWeight: "bold" }}> */}
                <div
                  style={{
                    textAlign: "center",
                    color: "#FFF",
                    fontWeight: "bold",
                  }}
                >
                  <div style={{ fontSize: "24px", marginBottom: "5px" }}>
                    🗑️
                  </div>
                  <div>Archive Task</div>
                </div>
              </div>
            );
          }
          return null;
        })()}
      </div>
    );
  }
}
